(function () {
    function parseProductJsonFromPage() {
      var el = document.querySelector('script[type="application/json"][data-tryon-page-product]');
      if (!el || !el.textContent || !String(el.textContent).trim()) {
        return null;
      }
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        console.warn("[TryOn] Invalid product JSON in page.", e);
        return null;
      }
    }
  
    /** Strip HTML from product body; decode entities via DOM. */
    function htmlToPlainText(html) {
      if (html == null || html === "") {
        return "";
      }
      var s = String(html).trim();
      if (!s) {
        return "";
      }
      var tmp = document.createElement("div");
      tmp.innerHTML = s;
      var text = tmp.textContent || tmp.innerText || "";
      return text.replace(/\s+/g, " ").trim();
    }
  
    /** garment_description: plain-text description, type, tags (no title). */
    function buildGarmentDescriptionKeyValues(p) {
      if (!p || typeof p !== "object") {
        return {
          description: "",
          type: "",
          tags: []
        };
      }
      var descRaw = p.description != null ? p.description : p.body_html;
      var ptype = p.type != null ? p.type : p.product_type;
      var tags = p.tags;
      if (!Array.isArray(tags)) {
        tags = tags != null && String(tags).length ? [String(tags)] : [];
      }
      return {
        description: htmlToPlainText(descRaw),
        type: ptype != null ? String(ptype) : "",
        tags: tags
      };
    }
  
    function getGarmentDescriptionForApi() {
      var p = parseProductJsonFromPage();
      return buildGarmentDescriptionKeyValues(p);
    }

    function getProductSubmissionMeta() {
      var p = parseProductJsonFromPage();
      var productName = p && p.title ? String(p.title) : "";
      var productUrl = "";
      if (p && p.url) {
        productUrl = String(p.url);
        if (productUrl.indexOf("http") !== 0) {
          productUrl = window.location.origin + (productUrl.charAt(0) === "/" ? productUrl : "/" + productUrl);
        }
      } else {
        productUrl = window.location.href.split("#")[0];
      }
      var code = "";
      if (p) {
        if (p.handle) {
          code = String(p.handle);
        } else if (p.id) {
          code = String(p.id);
        }
      }
      return {
        productName: productName,
        productUrl: productUrl,
        code: code
      };
    }
  
    /** Browser max JPEG quality for capture, watermark, and exported files. */
    var TRYON_JPEG_QUALITY = 1;
    var TRYON_DAILY_STATE_KEY = "br_tryon_daily_state";
    /** Camera rotation is a property of the shopper's hardware, so it outlives a session. */
    var TRYON_ROTATION_KEY = "br_tryon_camera_rotation";
    var TRYON_ROTATION_STEPS = [0, 90, 180, 270];
    var TRYON_DAILY_LIMIT = 10;
    var TRYON_LEGACY_STORAGE_KEYS = [
      "br_tryon_daily_generation",
      "br_tryon_successful_generation_count"
    ];
  
    function getLocalDateKey() {
      var d = new Date();
      var m = d.getMonth() + 1;
      var day = d.getDate();
      return d.getFullYear() + "-" + (m < 10 ? "0" : "") + m + "-" + (day < 10 ? "0" : "") + day;
    }
  
    function createFreshDailyState() {
      return {
        date: getLocalDateKey(),
        generationCount: 0,
        contactSubmitted: false,
        contact: null
      };
    }
  
    function clearTryOnDailyStorage() {
      var i;
      try {
        localStorage.removeItem(TRYON_DAILY_STATE_KEY);
        for (i = 0; i < TRYON_LEGACY_STORAGE_KEYS.length; i++) {
          localStorage.removeItem(TRYON_LEGACY_STORAGE_KEYS[i]);
        }
      } catch (e) {
        /* ignore */
      }
    }
  
    /** Drop yesterday's (or invalid) data — we only keep one small record for today. */
    function purgeStaleTryOnDailyStorage() {
      var today = getLocalDateKey();
      var i;
      try {
        for (i = 0; i < TRYON_LEGACY_STORAGE_KEYS.length; i++) {
          localStorage.removeItem(TRYON_LEGACY_STORAGE_KEYS[i]);
        }
        var raw = localStorage.getItem(TRYON_DAILY_STATE_KEY);
        if (!raw) {
          return;
        }
        var parsed = JSON.parse(raw);
        if (!parsed || parsed.date !== today) {
          clearTryOnDailyStorage();
        }
      } catch (e) {
        clearTryOnDailyStorage();
      }
    }
  
    function readDailyState() {
      try {
        var today = getLocalDateKey();
        var raw = localStorage.getItem(TRYON_DAILY_STATE_KEY);
        if (!raw) {
          return createFreshDailyState();
        }
        var parsed = JSON.parse(raw);
        if (!parsed || parsed.date !== today) {
          clearTryOnDailyStorage();
          return createFreshDailyState();
        }
        var genCount = parsed.generationCount;
        if (genCount == null && parsed.count != null) {
          genCount = parseInt(parsed.count, 10);
        } else {
          genCount = parseInt(genCount, 10);
        }
        if (isNaN(genCount) || genCount < 0) {
          genCount = 0;
        }
        var contact = null;
        if (parsed.contact && typeof parsed.contact === "object") {
          contact = {
            name: parsed.contact.name != null ? String(parsed.contact.name) : "",
            phone: parsed.contact.phone != null ? String(parsed.contact.phone) : "",
            countryCode:
              parsed.contact.countryCode != null ? String(parsed.contact.countryCode) : ""
          };
        }
        return {
          date: today,
          generationCount: genCount,
          contactSubmitted: parsed.contactSubmitted === true,
          contact: contact
        };
      } catch (e) {
        clearTryOnDailyStorage();
        return createFreshDailyState();
      }
    }
  
    function writeDailyState(state) {
      try {
        localStorage.setItem(TRYON_DAILY_STATE_KEY, JSON.stringify(state));
      } catch (e) {
        /* ignore */
      }
    }

    function readStoredRotation() {
      try {
        var stored = parseInt(localStorage.getItem(TRYON_ROTATION_KEY), 10);
        return TRYON_ROTATION_STEPS.indexOf(stored) === -1 ? 0 : stored;
      } catch (e) {
        return 0;
      }
    }

    function writeStoredRotation(degrees) {
      try {
        localStorage.setItem(TRYON_ROTATION_KEY, String(degrees));
      } catch (e) {
        /* ignore */
      }
    }
  
    function incrementSuccessfulGenerationCount() {
      var state = readDailyState();
      if ((state.generationCount || 0) >= TRYON_DAILY_LIMIT) {
        return;
      }
      state.generationCount = (state.generationCount || 0) + 1;
      writeDailyState(state);
    }

    function hasReachedDailyTryOnLimit(state) {
      state = state || readDailyState();
      return (state.generationCount || 0) >= TRYON_DAILY_LIMIT;
    }

    function getDailyTryOnLimitMessage() {
      return (
        "Daily try-on limit reached (" +
        TRYON_DAILY_LIMIT +
        " per day). Please try again tomorrow."
      );
    }
  
    function persistContactSubmitted(payload) {
      if (!payload) {
        return;
      }
      var state = readDailyState();
      state.contactSubmitted = true;
      state.contact = {
        name: payload.name,
        phone: payload.phoneE164 || payload.phone,
        countryCode: payload.countryCode || "",
        code: payload.code || ""
      };
      writeDailyState(state);
    }
  
    function normalizePhoneDigits(value, maxLen) {
      return String(value || "").replace(/\D/g, "").slice(0, maxLen != null ? maxLen : 15);
    }

    function getShopifyPhoneUtil() {
      if (!window.libphonenumber || !libphonenumber.PhoneNumberUtil) {
        return null;
      }
      return libphonenumber.PhoneNumberUtil.getInstance();
    }

    function getDialCodeForRegion(isoCode) {
      var util = getShopifyPhoneUtil();
      if (!util || !isoCode) {
        return "";
      }
      try {
        return String(util.getCountryCodeForRegion(String(isoCode).toUpperCase()));
      } catch (e) {
        return "";
      }
    }

    function validatePhoneForRegion(nationalNumber, regionCode) {
      var digits = normalizePhoneDigits(nationalNumber);
      if (!digits) {
        return false;
      }
      var util = getShopifyPhoneUtil();
      if (!util) {
        return digits.length >= 6 && digits.length <= 15;
      }
      try {
        var parsed = util.parse(String(digits), String(regionCode).toUpperCase());
        return util.isValidNumberForRegion(parsed, String(regionCode).toUpperCase());
      } catch (e) {
        return false;
      }
    }

    function formatPhoneE164(nationalNumber, regionCode) {
      var digits = normalizePhoneDigits(nationalNumber);
      if (!digits) {
        return "";
      }
      var util = getShopifyPhoneUtil();
      if (!util) {
        var dial = getDialCodeForRegion(regionCode);
        return dial ? "+" + dial + digits : digits;
      }
      try {
        var parsed = util.parse(String(digits), String(regionCode).toUpperCase());
        return util.format(parsed, libphonenumber.PhoneNumberFormat.E164);
      } catch (e) {
        return "";
      }
    }

    function splitPhoneNumber(rawPhone, fallbackRegion) {
      var util = getShopifyPhoneUtil();
      if (!util || !rawPhone) {
        return null;
      }
      try {
        var parsed = util.parse(String(rawPhone), fallbackRegion || undefined);
        var region = util.getRegionCodeForNumber(parsed) || fallbackRegion || "";
        var national = util.getNationalSignificantNumber(parsed);
        return {
          region: region,
          national: national,
          e164: util.format(parsed, libphonenumber.PhoneNumberFormat.E164)
        };
      } catch (e) {
        return null;
      }
    }

    function getRegionDisplayName(isoCode, displayNames) {
      var iso = String(isoCode || "").toUpperCase();
      if (!iso) {
        return "";
      }
      if (displayNames) {
        try {
          var label = displayNames.of(iso);
          if (label && label !== iso) {
            return label;
          }
        } catch (e) {
          /* ignore */
        }
      }
      return iso;
    }

    function regionsToArray(regions) {
      if (!regions) {
        return [];
      }
      if (Array.isArray(regions)) {
        return regions;
      }
      if (typeof regions.length === "number") {
        return Array.prototype.slice.call(regions);
      }
      var list = [];
      if (typeof regions.forEach === "function") {
        regions.forEach(function (region) {
          list.push(region);
        });
      }
      return list;
    }

    /** Global country list — same libphonenumber regions Shopify @shopify/phone uses. */
    function buildGlobalPhoneCountrySelect(selectEl) {
      if (!selectEl || selectEl.dataset.tryonCountriesBuilt === "true") {
        return !!selectEl;
      }

      var util = getShopifyPhoneUtil();
      if (!util) {
        return false;
      }

      var defaultIso = String(
        selectEl.getAttribute("data-default-country") || "IN"
      ).toUpperCase();
      var popularList = [];
      try {
        popularList = JSON.parse(selectEl.getAttribute("data-popular-countries") || "[]");
      } catch (e) {
        popularList = [];
      }
      popularList = popularList
        .map(function (code) {
          return String(code || "").toUpperCase();
        })
        .filter(function (code, index, arr) {
          return code && arr.indexOf(code) === index;
        });

      if (!popularList.length) {
        popularList = [defaultIso, "US", "GB", "CA", "AU"].filter(function (code, index, arr) {
          return code && arr.indexOf(code) === index;
        });
      }

      var displayNames = null;
      try {
        if (typeof Intl !== "undefined" && Intl.DisplayNames) {
          displayNames = new Intl.DisplayNames(["en"], { type: "region" });
        }
      } catch (e2) {
        displayNames = null;
      }

      var all = [];
      regionsToArray(util.getSupportedRegions()).forEach(function (iso) {
        iso = String(iso || "").toUpperCase();
        var dial = getDialCodeForRegion(iso);
        if (!dial) {
          return;
        }
        all.push({
          iso: iso,
          dial: dial,
          name: getRegionDisplayName(iso, displayNames)
        });
      });

      all.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });

      var byIso = {};
      all.forEach(function (item) {
        byIso[item.iso] = item;
      });

      selectEl.innerHTML = "";

      function appendOption(item) {
        var opt = document.createElement("option");
        opt.value = item.iso;
        opt.textContent = "+" + item.dial + " " + item.name;
        opt.setAttribute("data-dial-code", item.dial);
        opt.setAttribute("data-country-name", item.name);
        if (item.iso === defaultIso) {
          opt.selected = true;
        }
        return opt;
      }

      var popularGroup = document.createElement("optgroup");
      popularGroup.label = "Popular";
      var popularAdded = 0;
      popularList.forEach(function (iso) {
        if (byIso[iso]) {
          popularGroup.appendChild(appendOption(byIso[iso]));
          popularAdded += 1;
        }
      });
      if (popularAdded) {
        selectEl.appendChild(popularGroup);
      }

      var allGroup = document.createElement("optgroup");
      allGroup.label = popularAdded ? "All countries" : "Countries";
      all.forEach(function (item) {
        allGroup.appendChild(appendOption(item));
      });
      selectEl.appendChild(allGroup);

      if (!selectEl.value && all.length) {
        selectEl.value = defaultIso;
      }

      selectEl.dataset.tryonCountriesBuilt = "true";
      return true;
    }

    function ensureGlobalPhoneCountrySelect(selectEl) {
      if (!selectEl) {
        return false;
      }
      if (buildGlobalPhoneCountrySelect(selectEl)) {
        return true;
      }
      return false;
    }
  
    /** Prefer exact API error text for user-facing status messages. */
    function extractTryonApiErrorMessage(payload, bodyText, httpStatus) {
      var fallback =
        httpStatus != null ? "Server request failed (" + httpStatus + ")." : "Try-on failed. Please retry.";
  
      if (payload && typeof payload === "object") {
        if (typeof payload.error === "string" && payload.error.trim()) {
          return payload.error.trim();
        }
        if (payload.error && typeof payload.error === "object") {
          if (typeof payload.error.message === "string" && payload.error.message.trim()) {
            return payload.error.message.trim();
          }
          if (typeof payload.error.detail === "string" && payload.error.detail.trim()) {
            return payload.error.detail.trim();
          }
        }
        if (typeof payload.message === "string" && payload.message.trim()) {
          return payload.message.trim();
        }
        if (typeof payload.detail === "string" && payload.detail.trim()) {
          return payload.detail.trim();
        }
        if (typeof payload.reason === "string" && payload.reason.trim()) {
          return payload.reason.trim();
        }
        if (Array.isArray(payload.errors) && payload.errors.length) {
          var parts = payload.errors
            .map(function (entry) {
              if (typeof entry === "string") {
                return entry.trim();
              }
              if (entry && typeof entry.message === "string") {
                return entry.message.trim();
              }
              if (entry && typeof entry.msg === "string") {
                return entry.msg.trim();
              }
              return "";
            })
            .filter(Boolean);
          if (parts.length) {
            return parts.join(" ");
          }
        }
      }
  
      if (bodyText && typeof bodyText === "string") {
        var trimmed = bodyText.trim();
        if (trimmed) {
          try {
            var parsed = JSON.parse(trimmed);
            var fromJson = extractTryonApiErrorMessage(parsed, "", httpStatus);
            if (fromJson && fromJson.indexOf("Server request failed") !== 0) {
              return fromJson;
            }
          } catch (e) {
            if (trimmed.length < 800 && trimmed.indexOf("<") !== 0) {
              return trimmed;
            }
          }
        }
      }
  
      return fallback;
    }
  
    purgeStaleTryOnDailyStorage();
  
    function initTryOn(root) {
      if (!root || root.dataset.tryonReady === "true") {
        return;
      }
      root.dataset.tryonReady = "true";
  
      var modal = root.parentElement.querySelector("[data-tryon-modal]");
      if (!modal) {
        return;
      }
  
      var instanceId = root.getAttribute("data-tryon-instance");
      var openButtons;
      if (instanceId) {
        openButtons = document.querySelectorAll(
          '[data-tryon-instance="' + instanceId + '"][data-tryon-open]'
        );
      } else {
        openButtons = root.querySelectorAll("[data-tryon-open]");
      }
      var closeButtons = modal.querySelectorAll("[data-tryon-close]");
      var garmentImage = modal.querySelector("[data-tryon-garment]");
      var video = modal.querySelector("[data-tryon-video]");
      var canvas = modal.querySelector("[data-tryon-canvas]");
      var previewImage = modal.querySelector("[data-tryon-preview-image]");
      var resultImage = modal.querySelector("[data-tryon-result-image]");
      var uploadBox = modal.querySelector("[data-tryon-upload-trigger]");
      var cameraButton = modal.querySelector("[data-tryon-camera]");
      var chooseButton = modal.querySelector("[data-tryon-choose]");
      var fileInput = modal.querySelector("[data-tryon-file]");
      var statusNode = modal.querySelector("[data-tryon-status]");
      var loaderNode = modal.querySelector("[data-tryon-loader]");
      var loaderTextNode = modal.querySelector("[data-tryon-loader-text]");
      var cameraInstructionNode = modal.querySelector("[data-tryon-camera-instruction]");
      var cameraFlipButton = modal.querySelector("[data-tryon-camera-flip]");
      var cameraRotateButton = modal.querySelector("[data-tryon-camera-rotate]");
      var cameraRotateBadge = modal.querySelector("[data-tryon-camera-rotate-badge]");
      var cameraRotation = readStoredRotation();
      /* Reused each frame so rotating doesn't allocate a new canvas per pose tick. */
      var rotatedFrameCanvas = null;
      var countdownNode = modal.querySelector("[data-tryon-countdown]");
      var downloadButton = modal.querySelector("[data-tryon-download]");
      var shareButton = modal.querySelector("[data-tryon-share]");
      var regenerateButton = modal.querySelector("[data-tryon-regenerate]");
      var detailsModal = modal.querySelector("[data-tryon-details-modal]");
      var detailsTitleEl = modal.querySelector("[data-tryon-details-title]");
      var detailsInnerDialog = modal.querySelector("[data-tryon-details-dialog]");
      var detailsNameInput = modal.querySelector("[data-tryon-customer-name]");
      var detailsPhoneInput = modal.querySelector("[data-tryon-customer-phone]");
      var detailsPhoneCountry = modal.querySelector("[data-tryon-phone-country]");
      var detailsErrorNode = modal.querySelector("[data-tryon-details-error]");
      var detailsConsentInput = modal.querySelector("[data-tryon-consent]");
      var detailsSubmitButton = modal.querySelector("[data-tryon-details-submit]");
      var detailsCancelButton = modal.querySelector("[data-tryon-details-cancel]");
      var toolbarBusyEl = modal.querySelector("[data-tryon-toolbar-busy]");
      var toolbarBusyTextEl = modal.querySelector("[data-tryon-toolbar-busy-text]");
      var captureButton = modal.querySelector("[data-tryon-capture-btn]");
      var captureButtonLabel = captureButton
        ? captureButton.querySelector(".br-tryon-capture-btn__label")
        : null;
      var cameraErrorNode = modal.querySelector("[data-tryon-camera-error]");
      var CAPTURE_BUTTON_LABEL = "Capture";
      var activeGarmentOverride = "";
  
      var stream = null;
      var cameraFacingMode = "user";
      var isCameraCaptureInProgress = false;
      var captureTimer = null;
      var captureCountdownTimer = null;
      var countdownInterval = null;
      var pose = null;
      var poseReady = false;
      var poseFramePending = false;
      var latestPoseLandmarks = null;
      var faceDetector = null;
      var faceDetectorReady = false;
      var captureErrorClearTimer = null;
      var captureErrorActive = false;
      var poseMissStreak = 0;
      var CAPTURE_ERROR_DISPLAY_MS = 1500;
      var BLUR_MIN_SCORE = 22;
      var HUMAN_CHECK_TIMEOUT_MS = 2500;
      var FACE_CHECK_TIMEOUT_MS = 1200;
      var POSE_CHECK_TIMEOUT_MS = 1500;
      var HUMAN_MIN_VISIBILITY = 0.4;
      var HUMAN_MIN_VISIBILITY_REAR = 0.22;
      var PERSON_MIN_FRAME_HEIGHT_REAR = 0.22;
      var lastHumanDetected = false;
      var currentState = "empty";
      var isLoading = false;
      var isToolbarActionBusy = false;
      var isDetailsSubmitBusy = false;
      var detailsSubmitLabel = "Continue";
      var loadingTextInterval = null;
      var lastSourceBlob = null;
      var generatedBlob = null;
      var generatedFilename = "try-on-result.jpg";
      var loadingMessages = [
        "Analyzing model pose...",
        "Analyzing garment details...",
        "Fitting garment on your photo...",
        "Rendering final try-on image..."
      ];
      var contextMenuBlocker = null;
      var pageBackdrop = null;

      function initPhoneCountryDropdown() {
        if (!detailsPhoneCountry) {
          return;
        }
        if (!ensureGlobalPhoneCountrySelect(detailsPhoneCountry)) {
          window.setTimeout(initPhoneCountryDropdown, 120);
          return;
        }
        applyDefaultPhoneFromCustomer();
      }

      function getSelectedDialCode() {
        if (!detailsPhoneCountry) {
          return "";
        }
        var selected = detailsPhoneCountry.options[detailsPhoneCountry.selectedIndex];
        if (selected) {
          var fromOption = selected.getAttribute("data-dial-code");
          if (fromOption) {
            return fromOption;
          }
        }
        return getDialCodeForRegion(getSelectedPhoneRegion());
      }

      function getSelectedPhoneRegion() {
        if (!detailsPhoneCountry) {
          return "IN";
        }
        return String(detailsPhoneCountry.value || "IN").toUpperCase();
      }

      function applyDefaultPhoneFromCustomer() {
        if (!detailsPhoneInput || !detailsPhoneCountry) {
          return;
        }
        var raw = detailsPhoneInput.getAttribute("data-tryon-default-phone") || "";
        if (!raw) {
          return;
        }
        var split = splitPhoneNumber(raw, getSelectedPhoneRegion());
        if (!split) {
          detailsPhoneInput.value = normalizePhoneDigits(raw);
          return;
        }
        if (split.region) {
          detailsPhoneCountry.value = split.region;
        }
        detailsPhoneInput.value = split.national || normalizePhoneDigits(raw);
      }

      initPhoneCountryDropdown();

      if (detailsPhoneCountry) {
        detailsPhoneCountry.addEventListener("change", function () {
          setInputErrorState(detailsPhoneCountry, false);
          setInputErrorState(detailsPhoneInput, false);
          if (
            detailsErrorNode &&
            (detailsErrorNode.textContent.indexOf("valid mobile") !== -1 ||
              detailsErrorNode.textContent.indexOf("mobile number") !== -1)
          ) {
            setDetailsError("");
          }
        });
      }

      if (detailsPhoneInput) {
        detailsPhoneInput.addEventListener("input", function () {
          var digits = normalizePhoneDigits(detailsPhoneInput.value);
          if (detailsPhoneInput.value !== digits) {
            detailsPhoneInput.value = digits;
          }
          setInputErrorState(detailsPhoneInput, false);
          if (
            detailsErrorNode &&
            (detailsErrorNode.textContent.indexOf("valid mobile") !== -1 ||
              detailsErrorNode.textContent.indexOf("mobile number") !== -1)
          ) {
            setDetailsError("");
          }
        });
        detailsPhoneInput.addEventListener("paste", function (event) {
          event.preventDefault();
          var pasted = "";
          try {
            pasted = (event.clipboardData || window.clipboardData).getData("text");
          } catch (e) {
            pasted = "";
          }
          var combined = detailsPhoneInput.value + pasted;
          var split = splitPhoneNumber(combined, getSelectedPhoneRegion());
          if (split && split.national) {
            if (split.region && detailsPhoneCountry) {
              detailsPhoneCountry.value = split.region;
            }
            detailsPhoneInput.value = split.national;
          } else {
            detailsPhoneInput.value = normalizePhoneDigits(combined);
          }
        });
      }
  
      if (!openButtons.length || !uploadBox || !fileInput || !video || !canvas || !previewImage || !resultImage) {
        return;
      }
  
      /* Modal must live under document.body so position:fixed + z-index sit above .header-section (z-index:50).
         Nested inside product markup it can stack under the sticky header due to ancestor stacking contexts. */
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
  
      function ensurePageBackdrop() {
        if (!pageBackdrop) {
          pageBackdrop = document.createElement("div");
          pageBackdrop.className = "br-tryon-page-backdrop";
          pageBackdrop.setAttribute("aria-hidden", "true");
          pageBackdrop.addEventListener("click", function () {
            closeModal();
          });
        }
        if (pageBackdrop.parentElement !== document.body) {
          document.body.appendChild(pageBackdrop);
        }
        return pageBackdrop;
      }

      function showPageBackdrop() {
        var backdrop = ensurePageBackdrop();
        backdrop.classList.add("is-visible");
        backdrop.setAttribute("aria-hidden", "false");
      }

      function hidePageBackdrop() {
        if (!pageBackdrop) {
          return;
        }
        pageBackdrop.classList.remove("is-visible");
        pageBackdrop.setAttribute("aria-hidden", "true");
      }

      function setStatus(message, variant) {
        if (!statusNode) {
          return;
        }
        if (
          statusNode.getAttribute("data-sticky-error") === "true" &&
          variant !== "error"
        ) {
          return;
        }
        if (!message && statusNode.classList.contains("br-tryon-status--error")) {
          return;
        }
        statusNode.textContent = message || "";
        statusNode.classList.toggle("br-tryon-status--error", variant === "error");
        if (variant === "error" && message) {
          statusNode.setAttribute("data-sticky-error", "true");
        } else if (message || variant !== "error") {
          statusNode.removeAttribute("data-sticky-error");
        }
      }

      function setCameraError(message) {
        if (cameraErrorNode) {
          cameraErrorNode.textContent = message || "";
        }
      }

      function setCaptureError(message) {
        if (captureErrorClearTimer) {
          clearTimeout(captureErrorClearTimer);
          captureErrorClearTimer = null;
        }
        if (!message) {
          captureErrorActive = false;
          uploadBox.removeAttribute("data-capture-error-active");
          setStatus("");
          setCameraError("");
          if (statusNode) {
            statusNode.removeAttribute("data-sticky-error");
            statusNode.classList.remove("br-tryon-status--error");
          }
          return;
        }
        captureErrorActive = true;
        uploadBox.setAttribute("data-capture-error-active", "true");
        setCameraError(message);
        setCameraInstruction(message);
        if (statusNode) {
          statusNode.textContent = "";
          statusNode.removeAttribute("data-sticky-error");
          statusNode.classList.remove("br-tryon-status--error");
        }
        captureErrorClearTimer = setTimeout(function () {
          captureErrorActive = false;
          uploadBox.removeAttribute("data-capture-error-active");
          setCameraError("");
          if (statusNode) {
            statusNode.removeAttribute("data-sticky-error");
            statusNode.classList.remove("br-tryon-status--error");
            if (currentState === "camera") {
              statusNode.textContent = "Stand in middle for accurate outputs.";
            } else {
              statusNode.textContent = "";
            }
          }
          if (currentState === "camera" && cameraInstructionNode) {
            setCameraInstruction("Stand in middle for accurate outputs.");
          }
          captureErrorClearTimer = null;
        }, CAPTURE_ERROR_DISPLAY_MS);
      }

      async function resumeCameraAfterCaptureError(message, objectUrl) {
        if (objectUrl) {
          URL.revokeObjectURL(objectUrl);
        }
        previewImage.src = "";
        lastSourceBlob = null;
        setUploadState("camera");
        setCaptureError(message);
        try {
          await attachLiveCameraStream();
          setCameraInstruction("Stand in middle for accurate outputs.");
          setCaptureBusy(false);
        } catch (err) {
          setUploadState("empty");
          setCaptureError("Camera unavailable. Tap Camera to retry.");
          setCaptureBusy(false);
        }
      }
  
      function setCameraInstruction(message) {
        if (!cameraInstructionNode) {
          return;
        }
        cameraInstructionNode.textContent = message;
      }
  
      function setDetailsError(message) {
        if (detailsErrorNode) {
          detailsErrorNode.textContent = message || "";
        }
      }
  
      function getDetailsBusyLabel(actionLabel) {
        if (actionLabel === "generate") {
          return "Generating…";
        }
        if (actionLabel === "share") {
          return "Sharing…";
        }
        return "Downloading…";
      }
  
      function setDetailsSubmitBusy(busy, busyText) {
        isDetailsSubmitBusy = busy;
        if (detailsModal) {
          detailsModal.setAttribute("data-submit-busy", busy ? "true" : "false");
        }
        if (detailsSubmitButton) {
          detailsSubmitButton.disabled = busy;
          detailsSubmitButton.classList.toggle("is-busy", busy);
          detailsSubmitButton.setAttribute("aria-busy", busy ? "true" : "false");
          detailsSubmitButton.textContent = busy ? busyText || "Please wait…" : detailsSubmitLabel;
        }
        if (detailsCancelButton) {
          detailsCancelButton.disabled = busy;
        }
        if (detailsNameInput) {
          detailsNameInput.disabled = busy;
        }
        if (detailsPhoneInput) {
          detailsPhoneInput.disabled = busy;
        }
        if (detailsPhoneCountry) {
          detailsPhoneCountry.disabled = busy;
        }
        if (detailsConsentInput) {
          detailsConsentInput.disabled = busy;
        }
      }
  
      function setInputErrorState(input, hasError) {
        if (!input) {
          return;
        }
        input.classList.toggle("br-tryon-input-error", !!hasError);
      }
  
      function setUploadState(state) {
        currentState = state;
        uploadBox.setAttribute("data-state", state);
        if (state === "camera") {
          syncCameraView();
        }
        syncCaptureButtonReady();
      }

      function setCaptureBusy(busy, label) {
        isCameraCaptureInProgress = !!busy;
        uploadBox.setAttribute("data-capture-busy", busy ? "true" : "false");
        if (captureButton) {
          captureButton.classList.toggle("is-busy", !!busy);
          captureButton.setAttribute("aria-busy", busy ? "true" : "false");
        }
        if (captureButtonLabel) {
          captureButtonLabel.textContent = busy
            ? label || "Capturing…"
            : CAPTURE_BUTTON_LABEL;
        }
        if (cameraFlipButton) {
          cameraFlipButton.disabled = !!busy;
        }
        if (cameraRotateButton) {
          cameraRotateButton.disabled = !!busy;
        }
        syncCaptureButtonReady();
      }

      function syncCaptureButtonReady() {
        if (!captureButton) {
          return;
        }
        var ready =
          currentState === "camera" &&
          !isLoading &&
          isCaptureAllowed();
        captureButton.disabled = isCameraCaptureInProgress;
        captureButton.setAttribute("aria-disabled", ready && !isCameraCaptureInProgress ? "false" : "true");
        captureButton.classList.toggle("is-not-ready", !ready && !isCameraCaptureInProgress);
      }

      function getCaptureBlockedReason() {
        if (isCameraCaptureInProgress) {
          return "Capturing…";
        }
        return "";
      }
  
      function setCountdownValue(value) {
        if (!countdownNode) {
          return;
        }
        if (value) {
          countdownNode.textContent = String(value);
          uploadBox.setAttribute("data-countdown-active", "true");
        } else {
          countdownNode.textContent = "";
          uploadBox.setAttribute("data-countdown-active", "false");
        }
      }
  
      function setLoading(value, fixedMessage) {
        isLoading = value;
        uploadBox.setAttribute("data-loading", value ? "true" : "false");
        if (loaderNode) {
          loaderNode.setAttribute("aria-hidden", value ? "false" : "true");
        }
  
        if (loadingTextInterval) {
          clearInterval(loadingTextInterval);
          loadingTextInterval = null;
        }
        if (!loaderTextNode) {
          return;
        }
  
        if (value) {
          if (fixedMessage) {
            loaderTextNode.textContent = fixedMessage;
          } else {
            var messageIndex = 0;
            loaderTextNode.textContent = loadingMessages[messageIndex];
            loadingTextInterval = setInterval(function () {
              messageIndex = (messageIndex + 1) % loadingMessages.length;
              loaderTextNode.textContent = loadingMessages[messageIndex];
            }, 1400);
          }
        } else {
          loaderTextNode.textContent = loadingMessages[0];
        }
      }
  
      function setToolbarActionLoading(active, message) {
        isToolbarActionBusy = !!active;
        uploadBox.setAttribute("data-toolbar-busy", active ? "true" : "false");
        if (toolbarBusyEl) {
          if (active) {
            toolbarBusyEl.removeAttribute("hidden");
          } else {
            toolbarBusyEl.setAttribute("hidden", "");
          }
        }
        if (toolbarBusyTextEl) {
          toolbarBusyTextEl.textContent = active && message ? message : "";
        }
      }
  
      function nextPaint() {
        return new Promise(function (resolve) {
          requestAnimationFrame(function () {
            requestAnimationFrame(resolve);
          });
        });
      }
  
      /** Live store URL from Liquid (shop.url); used when theme dev serves images on localhost. */
      function getTryonStoreOrigin() {
        var origin = (modal.dataset.tryonStoreOrigin || "").trim().replace(/\/$/, "");
        if (origin) {
          return origin;
        }
        if (window.Shopify && Shopify.shop) {
          return "https://" + String(Shopify.shop).replace(/\/$/, "");
        }
        return "";
      }
  
      function toApiAccessibleGarmentUrl(url) {
        if (!url || typeof url !== "string") {
          return "";
        }
        var trimmed = url.trim();
        if (!trimmed) {
          return "";
        }
        try {
          var parsed = new URL(trimmed, window.location.href);
          if (parsed.hostname === "127.0.0.1" || parsed.hostname === "localhost") {
            var storeOrigin = getTryonStoreOrigin();
            if (storeOrigin) {
              return storeOrigin + parsed.pathname + parsed.search;
            }
          }
          return parsed.href;
        } catch (e) {
          return trimmed;
        }
      }
  
      function getProductDetailRoot() {
        return (
          document.querySelector("media-gallery") ||
          document.querySelector(".product") ||
          document.querySelector(".thb-product-detail")
        );
      }

      function imageUrlFrom(node) {
        if (!node) {
          return "";
        }
        return node.currentSrc || node.src || node.getAttribute("src") || "";
      }

      function imageFromMediaContainer(container) {
        if (!container) {
          return "";
        }
        var imageNode =
          container.querySelector(".product__media img") ||
          container.querySelector(".product-media-container img") ||
          container.querySelector(".product-single__media-image img") ||
          container.querySelector("img");
        return imageUrlFrom(imageNode);
      }

      function imageFromSlide(slide) {
        if (!slide) {
          return "";
        }
        return imageFromMediaContainer(slide);
      }

      function getGarmentUrlFromButton(button) {
        if (!button) {
          return "";
        }
        var fromContainer = imageFromMediaContainer(button.closest(".product-media-container"));
        if (fromContainer) {
          return fromContainer;
        }
        var fromSlide = imageFromSlide(
          button.closest(".product__media-item, .slider__slide, .product-images__slide")
        );
        return fromSlide || "";
      }

      function getActiveGarmentUrl() {
        if (activeGarmentOverride) {
          return toApiAccessibleGarmentUrl(activeGarmentOverride);
        }

        if (modal.dataset.tryonUseTestGarment === "true") {
          return toApiAccessibleGarmentUrl(modal.dataset.defaultGarment || "");
        }

        var detailRoot = getProductDetailRoot();
        if (!detailRoot) {
          return toApiAccessibleGarmentUrl(modal.dataset.defaultGarment || "");
        }

        // Dawn: active gallery slide.
        var dawnActiveSlide = detailRoot.querySelector(
          ".product__media-item.is-active, .product__media-item.slider__slide.is-active"
        );
        var dawnActiveUrl = imageFromSlide(dawnActiveSlide);
        if (dawnActiveUrl) {
          return toApiAccessibleGarmentUrl(dawnActiveUrl);
        }

        // Dawn: active thumbnail (aria-current or is-active).
        var dawnActiveThumb = detailRoot.querySelector(
          '.thumbnail-list__item[aria-current="true"], button.thumbnail[aria-current="true"], .thumbnail-list__item.is-active'
        );
        if (dawnActiveThumb) {
          var targetId =
            dawnActiveThumb.getAttribute("data-media-id") ||
            dawnActiveThumb.getAttribute("data-target") ||
            dawnActiveThumb.dataset.mediaId ||
            dawnActiveThumb.dataset.target;
          if (targetId) {
            var targetSlide = detailRoot.querySelector('[data-media-id="' + String(targetId) + '"]');
            if (!targetSlide && targetId.indexOf("Slide-") === 0) {
              targetSlide = detailRoot.querySelector("#" + String(targetId));
            }
            var targetUrl = imageFromSlide(targetSlide);
            if (targetUrl) {
              return toApiAccessibleGarmentUrl(targetUrl);
            }
          }
        }

        // Legacy theme: Flickity active slide.
        var selectedSlide = detailRoot.querySelector(".product-images__slide.is-selected");
        var selectedUrl = imageFromSlide(selectedSlide);
        if (selectedUrl) {
          return toApiAccessibleGarmentUrl(selectedUrl);
        }

        // Legacy theme: active slide state.
        var activeSlide = detailRoot.querySelector(".product-images__slide.is-active");
        var activeUrl = imageFromSlide(activeSlide);
        if (activeUrl) {
          return toApiAccessibleGarmentUrl(activeUrl);
        }

        // Legacy theme: active thumbnail mapped to corresponding slide id.
        var activeThumb = detailRoot.querySelector(
          ".product-thumbnail.is-active, .product-thumbnail.is-initial-selected"
        );
        if (activeThumb && activeThumb.id && activeThumb.id.indexOf("Thumb-") === 0) {
          var mappedSlide = detailRoot.querySelector(
            "#" + activeThumb.id.replace("Thumb-", "Slide-")
          );
          var mappedUrl = imageFromSlide(mappedSlide);
          if (mappedUrl) {
            return toApiAccessibleGarmentUrl(mappedUrl);
          }
        }

        // Final fallback to first gallery image.
        var fallbackImage = detailRoot.querySelector(
          ".product__media-item img, .product__media-list img, .product-images img"
        );
        return toApiAccessibleGarmentUrl(
          imageUrlFrom(fallbackImage) || modal.dataset.defaultGarment || ""
        );
      }
  
      function syncGarmentImage() {
        var garmentUrl = getActiveGarmentUrl();
        if (garmentUrl && garmentImage) {
          garmentImage.src = garmentUrl;
        }
        return garmentUrl;
      }
  
      /* 1080p stays sharp without the decode cost of a 4K stream, which made the preview
         stutter. No aspectRatio constraint: pinning it makes the browser crop the sensor. */
      function getCameraVideoConstraints() {
        return {
          facingMode: cameraFacingMode === "environment" ? { ideal: "environment" } : "user",
          width: { ideal: 1920 },
          height: { ideal: 1080 }
        };
      }

      async function attachLiveCameraStream() {
        try {
          stream = await navigator.mediaDevices.getUserMedia({
            video: getCameraVideoConstraints()
          });
        } catch (firstErr) {
          stream = await navigator.mediaDevices.getUserMedia({
            video:
              cameraFacingMode === "environment"
                ? { facingMode: { ideal: "environment" } }
                : { facingMode: "user" }
          });
        }
        video.srcObject = stream;
        video.playsInline = true;
        video.setAttribute("playsinline", "");
        video.muted = true;
        await video.play();
      }
  
      function stopCamera() {
        cancelCaptureCountdown();
        if (captureErrorClearTimer) {
          clearTimeout(captureErrorClearTimer);
          captureErrorClearTimer = null;
        }
        setCameraError("");
        if (countdownInterval) {
          clearInterval(countdownInterval);
          countdownInterval = null;
        }
        setCountdownValue("");
        if (captureTimer) {
          clearTimeout(captureTimer);
          captureTimer = null;
        }
        poseFramePending = false;
        latestPoseLandmarks = null;
        if (stream) {
          stream.getTracks().forEach(function (track) {
            track.stop();
          });
          stream = null;
        }
        if (video) {
          video.srcObject = null;
        }
      }
  
      function hasVisibility(landmark, min) {
        return !!landmark && typeof landmark.visibility === "number" && landmark.visibility >= min;
      }
  
      function withTimeout(promise, ms, fallbackValue) {
        return Promise.race([
          promise,
          new Promise(function (resolve) {
            setTimeout(function () {
              resolve(fallbackValue);
            }, ms);
          })
        ]);
      }

      function isLikelyBlankImage(source) {
        try {
          var w = source.width || source.videoWidth || source.naturalWidth || 0;
          var h = source.height || source.videoHeight || source.naturalHeight || 0;
          if (w < 2 || h < 2) {
            return true;
          }
          var sample = document.createElement("canvas");
          sample.width = 32;
          sample.height = 32;
          var ctx = sample.getContext("2d");
          ctx.drawImage(source, 0, 0, 32, 32);
          var data = ctx.getImageData(0, 0, 32, 32).data;
          var sum = 0;
          var sumSq = 0;
          var n = 0;
          var i = 0;
          for (i = 0; i < data.length; i += 4) {
            var lum = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
            sum += lum;
            sumSq += lum * lum;
            n += 1;
          }
          var mean = sum / n;
          var variance = sumSq / n - mean * mean;
          return variance < 80;
        } catch (blankErr) {
          return false;
        }
      }

      function isRearCamera() {
        return cameraFacingMode === "environment";
      }

      function isFullBodyFraming() {
        return (
          isRearCamera() ||
          (latestPoseLandmarks &&
            getPersonLandmarkHeightRatio(latestPoseLandmarks) >= PERSON_MIN_FRAME_HEIGHT_REAR)
        );
      }

      function getPersonLandmarkHeightRatio(landmarks) {
        if (!landmarks || !landmarks.length) {
          return 0;
        }
        var indices = [0, 11, 12, 23, 24, 25, 26, 27, 28];
        var minY = 1;
        var maxY = 0;
        var found = 0;
        var i = 0;
        for (i = 0; i < indices.length; i++) {
          var lm = landmarks[indices[i]];
          if (lm && typeof lm.y === "number" && hasVisibility(lm, 0.15)) {
            minY = Math.min(minY, lm.y);
            maxY = Math.max(maxY, lm.y);
            found += 1;
          }
        }
        if (found < 2) {
          return 0;
        }
        return maxY - minY;
      }

      function hasStrictPersonInLandmarks(landmarks) {
        if (!landmarks || !landmarks.length) {
          return false;
        }
        var minVis = HUMAN_MIN_VISIBILITY;
        var nose = hasVisibility(landmarks[0], minVis);
        var hasShoulder =
          hasVisibility(landmarks[11], minVis) || hasVisibility(landmarks[12], minVis);
        var hasHip =
          hasVisibility(landmarks[23], minVis) || hasVisibility(landmarks[24], minVis);
        if (nose && hasShoulder) {
          return true;
        }
        if (hasShoulder && hasHip) {
          return true;
        }
        if (nose && hasHip) {
          return true;
        }
        return false;
      }

      function hasFullBodyPersonInLandmarks(landmarks) {
        if (!landmarks || !landmarks.length) {
          return false;
        }
        var minVis = HUMAN_MIN_VISIBILITY_REAR;
        var nose = hasVisibility(landmarks[0], minVis);
        var hasShoulder =
          hasVisibility(landmarks[11], minVis) || hasVisibility(landmarks[12], minVis);
        var hasHip =
          hasVisibility(landmarks[23], minVis) || hasVisibility(landmarks[24], minVis);
        var hasKnee =
          hasVisibility(landmarks[25], minVis) || hasVisibility(landmarks[26], minVis);
        var visiblePoints = 0;
        var points = [0, 11, 12, 23, 24, 25, 26];
        var i = 0;
        for (i = 0; i < points.length; i++) {
          if (hasVisibility(landmarks[points[i]], minVis)) {
            visiblePoints += 1;
          }
        }
        var heightRatio = getPersonLandmarkHeightRatio(landmarks);
        if (hasShoulder && hasHip) {
          return true;
        }
        if (nose && hasShoulder) {
          return true;
        }
        if (hasShoulder && hasKnee && heightRatio >= PERSON_MIN_FRAME_HEIGHT_REAR) {
          return true;
        }
        if (visiblePoints >= 2 && heightRatio >= PERSON_MIN_FRAME_HEIGHT_REAR) {
          return true;
        }
        return false;
      }

      function hasPersonInLandmarks(landmarks) {
        if (!landmarks || !landmarks.length) {
          return false;
        }
        if (
          isRearCamera() ||
          getPersonLandmarkHeightRatio(landmarks) >= PERSON_MIN_FRAME_HEIGHT_REAR
        ) {
          return hasFullBodyPersonInLandmarks(landmarks);
        }
        return hasStrictPersonInLandmarks(landmarks);
      }

      function hasMinimalPersonInLandmarks(landmarks) {
        return hasPersonInLandmarks(landmarks);
      }

      async function checkHumanInSource(source, options) {
        options = options || {};
        if (!source) {
          return false;
        }

        if (isLikelyBlankImage(source)) {
          latestPoseLandmarks = null;
          poseMissStreak = 3;
          return false;
        }

        try {
          var faceFound = await withTimeout(
            detectFaceInSource(source),
            FACE_CHECK_TIMEOUT_MS,
            false
          );
          if (faceFound) {
            return true;
          }
        } catch (faceErr) {
          /* fall through to pose */
        }

        if (
          !options.requireFresh &&
          latestPoseLandmarks &&
          hasMinimalPersonInLandmarks(latestPoseLandmarks)
        ) {
          return true;
        }

        if (options.requireFresh) {
          latestPoseLandmarks = null;
        }

        var freshLandmarks = await withTimeout(
          runOneShotPose(source),
          POSE_CHECK_TIMEOUT_MS,
          null
        );
        if (freshLandmarks && freshLandmarks.length) {
          latestPoseLandmarks = freshLandmarks;
          poseMissStreak = 0;
          return hasMinimalPersonInLandmarks(freshLandmarks);
        }

        latestPoseLandmarks = null;
        poseMissStreak = 3;
        return false;
      }

      /* Live body detection used to gate this, but running pose and face models on every
         camera frame stalled the preview. Capture is now always available. */
      function isCaptureAllowed() {
        return true;
      }

      function getBodyWaitingMessage() {
        return "Stand in middle for accurate outputs.";
      }

      function runOneShotPose(source) {
        return new Promise(function (resolve) {
          if (!window.Pose || !source) {
            resolve(null);
            return;
          }
          var sw = source.videoWidth || source.naturalWidth || source.width || 1;
          var sh = source.videoHeight || source.naturalHeight || source.height || 1;
          if (sw < 2 || sh < 2) {
            resolve(null);
            return;
          }
          var poseCanvas = document.createElement("canvas");
          var maxSide = 480;
          var scale = Math.min(1, maxSide / Math.max(sw, sh));
          poseCanvas.width = Math.max(2, Math.round(sw * scale));
          poseCanvas.height = Math.max(2, Math.round(sh * scale));
          poseCanvas.getContext("2d").drawImage(source, 0, 0, poseCanvas.width, poseCanvas.height);

          var settled = false;
          function finish(result) {
            if (settled) {
              return;
            }
            settled = true;
            resolve(result);
          }

          var oneShotPose = new window.Pose({
            locateFile: function (f) {
              return "https://cdn.jsdelivr.net/npm/@mediapipe/pose/" + f;
            }
          });
          var rear = cameraFacingMode === "environment";
          oneShotPose.setOptions({
            modelComplexity: 0,
            smoothLandmarks: false,
            enableSegmentation: false,
            minDetectionConfidence: rear ? 0.3 : 0.35,
            minTrackingConfidence: rear ? 0.3 : 0.35
          });
          oneShotPose.onResults(function (results) {
            try {
              oneShotPose.close();
            } catch (closeErr) {
              /* ignore */
            }
            finish(results && results.poseLandmarks ? results.poseLandmarks : null);
          });
          oneShotPose.send({ image: poseCanvas }).catch(function () {
            try {
              oneShotPose.close();
            } catch (closeErr2) {
              /* ignore */
            }
            finish(null);
          });
        });
      }

      async function refreshPoseFromVideo() {
        if (!video || currentState !== "camera") {
          return lastHumanDetected;
        }
        lastHumanDetected = await checkHumanInSource(video);
        return lastHumanDetected;
      }

      /**
       * Use OpenCV to verify required body regions exist in the image.
       * For lower garments: requires face, waist, and knees
       * For fullbody garments: requires face, shoulders, and chest (more lenient)
       * Returns true if all required regions have sufficient content, false otherwise.
       */
      async function verifyFullBodyRegionsWithOpenCV(imgEl, garmentType) {
        // Wait for OpenCV to be ready
        var waited = 0;
        while (typeof cv === 'undefined' && waited < 8000) {
          await new Promise(function (r) { setTimeout(r, 200); });
          waited += 200;
        }
        
        if (typeof cv === 'undefined') {
          console.warn('[TryOn] OpenCV not loaded for body verification');
          return true; // Fallback to allow if OpenCV fails
        }

        try {
          var width = imgEl.naturalWidth || imgEl.width || 1;
          var height = imgEl.naturalHeight || imgEl.height || 1;
          
          var tempCanvas = document.createElement('canvas');
          tempCanvas.width = width;
          tempCanvas.height = height;
          tempCanvas.getContext('2d').drawImage(imgEl, 0, 0);

          var src = cv.imread(tempCanvas);
          var gray = new cv.Mat();
          var edges = new cv.Mat();

          // Convert to grayscale
          cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);
          
          // Apply Canny edge detection to find content regions
          cv.Canny(gray, edges, 50, 150);

          if (garmentType === 'lower') {
            // STRICT: For pants/skirts - require face, waist, and knees
            // Face region: top 25% (0% - 25%)
            // Waist region: middle 25% (40% - 65%)
            // Knee region: lower 25% (65% - 90%)
            
            var faceRegionHeight = Math.floor(height * 0.25);
            var waistRegionStart = Math.floor(height * 0.40);
            var waistRegionHeight = Math.floor(height * 0.25);
            var kneeRegionStart = Math.floor(height * 0.65);
            var kneeRegionHeight = Math.floor(height * 0.25);

            var faceRegion = edges.roi(new cv.Rect(0, 0, width, faceRegionHeight));
            var waistRegion = edges.roi(new cv.Rect(0, waistRegionStart, width, waistRegionHeight));
            var kneeRegion = edges.roi(new cv.Rect(0, kneeRegionStart, width, kneeRegionHeight));

            var facePixels = cv.countNonZero(faceRegion);
            var waistPixels = cv.countNonZero(waistRegion);
            var kneePixels = cv.countNonZero(kneeRegion);

            var faceRegionArea = width * faceRegionHeight;
            var waistRegionArea = width * waistRegionHeight;
            var kneeRegionArea = width * kneeRegionHeight;

            var faceDensity = facePixels / faceRegionArea;
            var waistDensity = waistPixels / waistRegionArea;
            var kneeDensity = kneePixels / kneeRegionArea;

            // Debug logging
            console.log('[TryOn] Lower garment OpenCV check:', {
              faceDensity: faceDensity.toFixed(4),
              waistDensity: waistDensity.toFixed(4),
              kneeDensity: kneeDensity.toFixed(4)
            });

            // Cleanup
            src.delete();
            gray.delete();
            edges.delete();
            faceRegion.delete();
            waistRegion.delete();
            kneeRegion.delete();

            // VERY STRICT thresholds for lower garments
            var hasFace = faceDensity > 0.03;
            var hasWaist = waistDensity > 0.03;
            var hasKnees = kneeDensity > 0.03;
            
            // Knee region must have at least 70% of face region density
            var kneeToFaceRatio = faceDensity > 0 ? (kneeDensity / faceDensity) : 0;
            var hasProportionalKnees = kneeToFaceRatio > 0.7;
            
            // Waist must have strong presence (not just background)
            var waistToFaceRatio = faceDensity > 0 ? (waistDensity / faceDensity) : 0;
            var hasStrongWaist = waistToFaceRatio > 0.6;

            console.log('[TryOn] Lower garment ratios:', {
              kneeToFaceRatio: kneeToFaceRatio.toFixed(4),
              waistToFaceRatio: waistToFaceRatio.toFixed(4),
              hasFace: hasFace,
              hasWaist: hasWaist,
              hasKnees: hasKnees,
              hasProportionalKnees: hasProportionalKnees,
              hasStrongWaist: hasStrongWaist
            });

            return hasFace && hasWaist && hasKnees && hasProportionalKnees && hasStrongWaist;
          } else {
            // LENIENT: For fullbody/dresses - only require face, shoulders, chest
            // Face region: top 20% (0% - 20%)
            // Shoulder region: 15% - 40%
            // Chest region: 35% - 60%
            
            var faceRegionHeight = Math.floor(height * 0.20);
            var shoulderRegionStart = Math.floor(height * 0.15);
            var shoulderRegionHeight = Math.floor(height * 0.25);
            var chestRegionStart = Math.floor(height * 0.35);
            var chestRegionHeight = Math.floor(height * 0.25);

            var faceRegion = edges.roi(new cv.Rect(0, 0, width, faceRegionHeight));
            var shoulderRegion = edges.roi(new cv.Rect(0, shoulderRegionStart, width, shoulderRegionHeight));
            var chestRegion = edges.roi(new cv.Rect(0, chestRegionStart, width, chestRegionHeight));

            var facePixels = cv.countNonZero(faceRegion);
            var shoulderPixels = cv.countNonZero(shoulderRegion);
            var chestPixels = cv.countNonZero(chestRegion);

            var faceRegionArea = width * faceRegionHeight;
            var shoulderRegionArea = width * shoulderRegionHeight;
            var chestRegionArea = width * chestRegionHeight;

            var faceDensity = facePixels / faceRegionArea;
            var shoulderDensity = shoulderPixels / shoulderRegionArea;
            var chestDensity = chestPixels / chestRegionArea;

            // Cleanup
            src.delete();
            gray.delete();
            edges.delete();
            faceRegion.delete();
            shoulderRegion.delete();
            chestRegion.delete();

            var hasFace = faceDensity > 0.03;
            var hasShoulders = shoulderDensity > 0.02;
            var hasChest = chestDensity > 0.02;

            return hasFace && hasShoulders && hasChest;
          }
        } catch (err) {
          console.warn('[TryOn] OpenCV body verification failed:', err);
          return true; // Fallback to allow if OpenCV fails
        }
      }

      /**
       * REDESIGNED GARMENT DETECTION SYSTEM
       * Uses structure-based analysis instead of pixel statistics
       * Separate pipelines for product images vs lifestyle photos
       */

      // ========== STEP 1: IMAGE TYPE DETECTION ==========
      async function detectImageType(imgEl) {
        if (!imgEl) return 'unknown';
        
        try {
          var canvas = document.createElement('canvas');
          var w = imgEl.naturalWidth || imgEl.width || 1;
          var h = imgEl.naturalHeight || imgEl.height || 1;
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(imgEl, 0, 0);
          
          // Check 1: Face detection (strong indicator of lifestyle)
          var hasFace = await detectFaceInSource(canvas);
          if (hasFace) {
            console.log('[TryOn] Face detected → lifestyle image');
            return 'lifestyle';
          }
          
          var imageData = ctx.getImageData(0, 0, w, h);
          var data = imageData.data;
          var totalPixels = w * h;
          var whitePixels = 0;
          var nearWhitePixels = 0;
          var colorfulPixels = 0;
          var skinTonePixels = 0;
          
          for (var i = 0; i < data.length; i += 4) {
            var r = data[i];
            var g = data[i + 1];
            var b = data[i + 2];
            var a = data[i + 3];
            
            // Count transparent/white pixels (product background)
            if (a < 50) {
              whitePixels++;
            } else if (r > 240 && g > 240 && b > 240) {
              whitePixels++;
            } else if (r > 220 && g > 220 && b > 220) {
              nearWhitePixels++;
            } else {
              // Count skin tone pixels (lifestyle indicator)
              var isSkinTone = (r > 180 && r < 255 && g > 130 && g < 220 && b > 100 && b < 200);
              if (isSkinTone) {
                skinTonePixels++;
              }
              
              // Count colorful pixels (complex background)
              var variance = Math.abs(r - g) + Math.abs(g - b) + Math.abs(b - r);
              if (variance > 30) {
                colorfulPixels++;
              }
            }
          }
          
          var whiteBgRatio = (whitePixels + nearWhitePixels) / totalPixels;
          var skinRatio = skinTonePixels / totalPixels;
          var colorRatio = colorfulPixels / totalPixels;
          
          console.log('[TryOn] Image analysis:', {
            whiteBgRatio: (whiteBgRatio * 100).toFixed(1) + '%',
            skinRatio: (skinRatio * 100).toFixed(1) + '%',
            colorRatio: (colorRatio * 100).toFixed(1) + '%'
          });
          
          // If significant skin tone detected → lifestyle
          if (skinRatio > 0.08) {
            console.log('[TryOn] Skin tone detected → lifestyle image');
            return 'lifestyle';
          }
          
          // If complex colorful background → lifestyle
          if (colorRatio > 0.35 && whiteBgRatio < 0.5) {
            console.log('[TryOn] Complex background → lifestyle image');
            return 'lifestyle';
          }
          
          // If mostly white/clean background → product
          if (whiteBgRatio > 0.6) {
            console.log('[TryOn] Clean background → product image');
            return 'product';
          }
          
          // Default: treat as lifestyle if ambiguous (safer for validation)
          console.log('[TryOn] Ambiguous → defaulting to lifestyle');
          return 'lifestyle';
        } catch (err) {
          console.warn('[TryOn] Image type detection failed:', err);
          return 'lifestyle';
        }
      }

      // ========== LIFESTYLE IMAGE: POSE-BASED DETECTION ==========
      async function detectGarmentTypeFromPose(imgEl) {
        try {
          // Ensure Pose is loaded
          if (!window.Pose) {
            console.warn('[TryOn] MediaPipe Pose not available - waiting...');
            await ensurePoseReady();
          }
          
          if (!window.Pose) {
            console.warn('[TryOn] MediaPipe Pose failed to load - defaulting to fullbody');
            return 'fullbody';
          }
          
          var w = imgEl.naturalWidth || imgEl.width || 1;
          var h = imgEl.naturalHeight || imgEl.height || 1;
          var poseCanvas = document.createElement('canvas');
          poseCanvas.width = w;
          poseCanvas.height = h;
          poseCanvas.getContext('2d').drawImage(imgEl, 0, 0);

          console.log('[TryOn] Starting pose detection on', w, 'x', h, 'image');

          return new Promise(function(resolve) {
            var timeoutId = setTimeout(function() {
              console.warn('[TryOn] Pose detection timeout - defaulting to fullbody');
              resolve('fullbody');
            }, 10000);

            var oneShotPose = new window.Pose({
              locateFile: function (f) {
                return "https://cdn.jsdelivr.net/npm/@mediapipe/pose/" + f;
              }
            });
            oneShotPose.setOptions({
              modelComplexity: 1,
              smoothLandmarks: false,
              enableSegmentation: false,
              minDetectionConfidence: 0.2,
              minTrackingConfidence: 0.2
            });
            
            oneShotPose.onResults(function (results) {
              clearTimeout(timeoutId);
              
              var lm = results && results.poseLandmarks ? results.poseLandmarks : null;

              console.log('[TryOn] Pose results received:', {
                hasLandmarks: !!lm,
                landmarkCount: lm ? lm.length : 0
              });

              // If no pose detected, check if it's a cropped lower-body photo
              if (!lm || !lm.length) {
                console.log('[TryOn] No pose landmarks - checking if cropped lower-body photo');
                
                // Check aspect ratio - if very tall and narrow, likely pants-only
                var aspectRatio = h / w;
                if (aspectRatio > 1.3) {
                  console.log('[TryOn] Tall narrow image without pose → likely cropped LOWER garment photo');
                  resolve('lower');
                  return;
                }
                
                console.log('[TryOn] No pose detected in lifestyle image → defaulting to fullbody');
                resolve('fullbody');
                return;
              }

              var nose = lm[0];
              var leftShoulder = lm[11];
              var rightShoulder = lm[12];
              var leftHip = lm[23];
              var rightHip = lm[24];
              var leftKnee = lm[25];
              var rightKnee = lm[26];
              var leftAnkle = lm[27];
              var rightAnkle = lm[28];

              var leftHipVis = (leftHip && typeof leftHip.visibility === 'number') ? leftHip.visibility : 0;
              var rightHipVis = (rightHip && typeof rightHip.visibility === 'number') ? rightHip.visibility : 0;
              var bestHipVis = Math.max(leftHipVis, rightHipVis);
              
              var leftKneeVis = (leftKnee && typeof leftKnee.visibility === 'number') ? leftKnee.visibility : 0;
              var rightKneeVis = (rightKnee && typeof rightKnee.visibility === 'number') ? rightKnee.visibility : 0;
              var bestKneeVis = Math.max(leftKneeVis, rightKneeVis);
              
              var leftAnkleVis = (leftAnkle && typeof leftAnkle.visibility === 'number') ? leftAnkle.visibility : 0;
              var rightAnkleVis = (rightAnkle && typeof rightAnkle.visibility === 'number') ? rightAnkle.visibility : 0;
              var bestAnkleVis = Math.max(leftAnkleVis, rightAnkleVis);

              var hipY = 0;
              if (leftHip && rightHip) {
                hipY = (leftHip.y + rightHip.y) / 2;
              } else if (leftHip) {
                hipY = leftHip.y;
              } else if (rightHip) {
                hipY = rightHip.y;
              }

              var ankleY = 0;
              if (leftAnkle && rightAnkle) {
                ankleY = (leftAnkle.y + rightAnkle.y) / 2;
              } else if (leftAnkle) {
                ankleY = leftAnkle.y;
              } else if (rightAnkle) {
                ankleY = rightAnkle.y;
              }

              console.log('[TryOn] Pose-based analysis:', {
                hipY: hipY.toFixed(3),
                ankleY: ankleY.toFixed(3),
                hipVis: bestHipVis.toFixed(3),
                kneeVis: bestKneeVis.toFixed(3),
                ankleVis: bestAnkleVis.toFixed(3)
              });

              // Check nose visibility (face present)
              var noseVis = (nose && typeof nose.visibility === 'number') ? nose.visibility : 0;
              var hasFace = noseVis > 0.3;

              // RULE 1: If face NOT visible → cropped photo
              if (!hasFace) {
                // Cropped to waist/legs only → LOWER
                if (bestHipVis >= 0.3 && bestKneeVis >= 0.4) {
                  console.log('[TryOn] No face, waist+legs visible → cropped LOWER garment photo');
                  resolve('lower');
                  return;
                }
                console.log('[TryOn] No face detected → defaulting to FULLBODY');
                resolve('fullbody');
                return;
              }

              // RULE 2: Face visible but waist NOT visible → UPPER only
              if (bestHipVis < 0.3) {
                console.log('[TryOn] Face visible, waist not visible → UPPER garment');
                resolve('upper');
                return;
              }

              // RULE 3: Face + waist visible, but knees NOT visible → could be upper or fullbody
              if (bestKneeVis < 0.4) {
                if (hipY > 0.7) {
                  console.log('[TryOn] Photo ends at waist → UPPER garment');
                  resolve('upper');
                  return;
                }
                console.log('[TryOn] Face+waist visible, knees cropped → FULLBODY');
                resolve('fullbody');
                return;
              }

              // RULE 4: Face + waist + knees visible, but ankles NOT visible
              if (bestAnkleVis < 0.3) {
                console.log('[TryOn] Face+waist+knees visible, ankles not → FULLBODY (dress/long garment)');
                resolve('fullbody');
                return;
              }

              // RULE 5: Face + waist + knees + ankles ALL visible
              // This is the critical case: could be pants OR fullbody outfit
              // Key: Check if this is a fashion photo (likely fullbody outfit) vs cropped product shot
              if (bestHipVis >= 0.3 && bestKneeVis >= 0.4 && bestAnkleVis >= 0.3) {
                // If face is in frame AND full legs visible → likely FULLBODY outfit/dress
                // (Fashion photos showing complete outfit)
                if (hasFace && ankleY > 0.75) {
                  console.log('[TryOn] Face + full body visible → FULLBODY outfit/dress (fashion photo)');
                  resolve('fullbody');
                  return;
                }
                
                // If face cropped but legs fully visible → LOWER (pants product photo)
                console.log('[TryOn] Legs visible without clear face → LOWER garment');
                resolve('lower');
                return;
              }

              console.log('[TryOn] Ambiguous pose → FULLBODY');
              resolve('fullbody');
            });

            console.log('[TryOn] Sending image to pose detector...');
            oneShotPose.send({ image: poseCanvas }).catch(function (err) {
              clearTimeout(timeoutId);
              console.warn('[TryOn] Pose detection failed:', err);
              resolve('fullbody');
            });
          });
        } catch (err) {
          console.warn('[TryOn] Pose-based detection error:', err);
          return 'fullbody';
        }
      }

      // ========== STEP 2: GARMENT SEGMENTATION ==========
      async function segmentGarment(imgEl) {
        var waited = 0;
        while (typeof cv === 'undefined' && waited < 8000) {
          await new Promise(function (r) { setTimeout(r, 200); });
          waited += 200;
        }
        
        if (typeof cv === 'undefined') {
          return null;
        }

        try {
          var canvas = document.createElement('canvas');
          var w = imgEl.naturalWidth || imgEl.width || 1;
          var h = imgEl.naturalHeight || imgEl.height || 1;
          canvas.width = w;
          canvas.height = h;
          canvas.getContext('2d').drawImage(imgEl, 0, 0);

          var src = cv.imread(canvas);
          var gray = new cv.Mat();
          var binary = new cv.Mat();

          cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);
          cv.threshold(gray, binary, 240, 255, cv.THRESH_BINARY_INV);

          var contours = new cv.MatVector();
          var hierarchy = new cv.Mat();
          cv.findContours(binary, contours, hierarchy, cv.RETR_EXTERNAL, cv.CHAIN_APPROX_SIMPLE);

          var largestContour = null;
          var maxArea = 0;
          for (var i = 0; i < contours.size(); i++) {
            var cnt = contours.get(i);
            var area = cv.contourArea(cnt);
            if (area > maxArea) {
              maxArea = area;
              largestContour = cnt;
            }
          }

          var result = {
            contour: largestContour,
            mask: binary.clone(),
            gray: gray.clone(),
            width: w,
            height: h
          };

          src.delete();
          gray.delete();
          binary.delete();
          contours.delete();
          hierarchy.delete();

          return result;
        } catch (err) {
          console.warn('[TryOn] Segmentation failed:', err);
          return null;
        }
      }

      // ========== STEP 3: FEATURE EXTRACTION ==========
      function extractStructuralFeatures(segmentData) {
        if (!segmentData || !segmentData.contour) {
          return null;
        }

        try {
          var contour = segmentData.contour;
          var w = segmentData.width;
          var h = segmentData.height;
          var mask = segmentData.mask;

          var boundingRect = cv.boundingRect(contour);
          var aspectRatio = boundingRect.height / boundingRect.width;
          
          var topThird = Math.floor(boundingRect.y + boundingRect.height * 0.33);
          var midThird = Math.floor(boundingRect.y + boundingRect.height * 0.66);
          
          var topRegion = mask.roi(new cv.Rect(boundingRect.x, boundingRect.y, boundingRect.width, topThird - boundingRect.y));
          var midRegion = mask.roi(new cv.Rect(boundingRect.x, topThird, boundingRect.width, midThird - topThird));
          var botRegion = mask.roi(new cv.Rect(boundingRect.x, midThird, boundingRect.width, (boundingRect.y + boundingRect.height) - midThird));

          var topPixels = cv.countNonZero(topRegion);
          var midPixels = cv.countNonZero(midRegion);
          var botPixels = cv.countNonZero(botRegion);
          var totalPixels = topPixels + midPixels + botPixels;

          var topRatio = totalPixels > 0 ? topPixels / totalPixels : 0;
          var midRatio = totalPixels > 0 ? midPixels / totalPixels : 0;
          var botRatio = totalPixels > 0 ? botPixels / totalPixels : 0;

          var edges = new cv.Mat();
          cv.Canny(segmentData.gray, edges, 50, 150);
          
          var topEdgeRegion = edges.roi(new cv.Rect(boundingRect.x, boundingRect.y, boundingRect.width, Math.floor(boundingRect.height * 0.2)));
          var botEdgeRegion = edges.roi(new cv.Rect(boundingRect.x, boundingRect.y + Math.floor(boundingRect.height * 0.8), boundingRect.width, Math.floor(boundingRect.height * 0.2)));
          
          var topEdges = cv.countNonZero(topEdgeRegion);
          var botEdges = cv.countNonZero(botEdgeRegion);

          var convexHull = new cv.Mat();
          cv.convexHull(contour, convexHull);
          var solidity = cv.contourArea(contour) / cv.contourArea(convexHull);

          topRegion.delete();
          midRegion.delete();
          botRegion.delete();
          edges.delete();
          topEdgeRegion.delete();
          botEdgeRegion.delete();
          convexHull.delete();

          return {
            aspectRatio: aspectRatio,
            topRatio: topRatio,
            midRatio: midRatio,
            botRatio: botRatio,
            topEdges: topEdges,
            botEdges: botEdges,
            solidity: solidity,
            hasNeckline: topEdges > botEdges * 1.3,
            hasLegs: botEdges > topEdges * 1.2,
            isContinuous: Math.abs(topRatio - botRatio) < 0.15
          };
        } catch (err) {
          console.warn('[TryOn] Feature extraction failed:', err);
          return null;
        }
      }

      // ========== STEP 4: CLASSIFICATION ==========
      function classifyFromFeatures(features) {
        if (!features) {
          return { type: 'fullbody', confidence: 0.4, reason: 'Feature extraction failed' };
        }

        var upperScore = 0;
        var lowerScore = 0;
        var fullbodyScore = 0;
        var reasons = [];

        // CRITICAL: Neckline detection
        if (features.hasNeckline && features.topEdges > 50) {
          if (features.aspectRatio < 1.2) {
            upperScore += 40;
            reasons.push('Neckline detected with short aspect ratio');
          } else if (features.aspectRatio >= 1.2 && features.aspectRatio < 1.8) {
            fullbodyScore += 35;
            reasons.push('Neckline with medium length suggests dress/fullbody');
          } else {
            fullbodyScore += 30;
            reasons.push('Neckline with long length suggests coat/fullbody');
          }
        }

        // Leg openings detection
        if (features.hasLegs && features.botEdges > 50) {
          if (!features.hasNeckline) {
            lowerScore += 40;
            reasons.push('Leg openings without neckline indicates pants');
          } else {
            fullbodyScore += 25;
            reasons.push('Both neckline and leg structure indicates jumpsuit/fullbody');
          }
        }

        // Continuous garment
        if (features.isContinuous && features.topRatio > 0.25 && features.botRatio > 0.25) {
          fullbodyScore += 20;
          reasons.push('Continuous distribution suggests dress/fullbody');
        }

        // Top-heavy garments
        if (features.topRatio > 0.45 && features.botRatio < 0.25) {
          upperScore += 25;
          reasons.push('Top-heavy distribution indicates shirt/jacket');
        }

        // Bottom-heavy garments WITHOUT neckline
        if (features.botRatio > 0.45 && features.topRatio < 0.25 && !features.hasNeckline) {
          lowerScore += 30;
          reasons.push('Bottom-heavy without neckline indicates pants');
        }

        // Aspect ratio (secondary indicator)
        if (features.aspectRatio < 0.9) {
          upperScore += 15;
          reasons.push('Wide aspect ratio');
        } else if (features.aspectRatio > 1.8 && !features.hasNeckline) {
          lowerScore += 15;
          reasons.push('Tall without neckline');
        }

        // Solidity check
        if (features.solidity > 0.85) {
          fullbodyScore += 10;
          reasons.push('High solidity indicates single piece garment');
        }

        var maxScore = Math.max(upperScore, lowerScore, fullbodyScore);
        var confidence = Math.min(maxScore / 100, 1.0);
        
        var type;
        if (confidence < 0.7) {
          type = 'fullbody';
          reasons.push('Low confidence - defaulting to fullbody for safety');
        } else if (upperScore === maxScore) {
          type = 'upper';
        } else if (lowerScore === maxScore) {
          type = 'lower';
        } else {
          type = 'fullbody';
        }

        return {
          type: type,
          confidence: confidence,
          reason: reasons.join('; '),
          scores: { upper: upperScore, lower: lowerScore, fullbody: fullbodyScore }
        };
      }

      // ========== MAIN DETECTION FUNCTION ==========
      async function detectGarmentType(garmentUrl) {
        try {
          var garmentImg = await imageFromUrl(garmentUrl, true).catch(function() {
            return imageFromUrl(garmentUrl, false);
          });

          var imageType = await detectImageType(garmentImg);
          console.log('[TryOn] Image type:', imageType);

          if (imageType === 'lifestyle') {
            console.log('[TryOn] Lifestyle image - using pose-based detection');
            return await detectGarmentTypeFromPose(garmentImg);
          }

          var segmentData = await segmentGarment(garmentImg);
          if (!segmentData) {
            console.warn('[TryOn] Segmentation failed - defaulting to fullbody');
            return 'fullbody';
          }

          var features = extractStructuralFeatures(segmentData);
          if (segmentData.mask) segmentData.mask.delete();
          if (segmentData.gray) segmentData.gray.delete();
          
          if (!features) {
            console.warn('[TryOn] Feature extraction failed - defaulting to fullbody');
            return 'fullbody';
          }

          var classification = classifyFromFeatures(features);
          
          console.log('[TryOn] Classification result:', {
            type: classification.type,
            confidence: (classification.confidence * 100).toFixed(1) + '%',
            reason: classification.reason,
            scores: classification.scores,
            features: features
          });

          return classification.type;
        } catch (err) {
          console.warn('[TryOn] Garment detection error:', err);
          return 'fullbody';
        }
      }

      /**
       * Uses Laplacian variance on the full frame (works for face and full-body shots).
       */
      function getImageBlurScore(imgEl) {
        try {
          var SIZE = 400;
          var c = document.createElement("canvas");
          c.width = SIZE;
          c.height = SIZE;
          c.getContext("2d").drawImage(imgEl, 0, 0, SIZE, SIZE);
          var imgData = c.getContext("2d").getImageData(0, 0, SIZE, SIZE);
          var data = imgData.data;

          var gray = new Float32Array(SIZE * SIZE);
          for (var i = 0; i < SIZE * SIZE; i++) {
            var idx = i * 4;
            gray[i] = 0.299 * data[idx] + 0.587 * data[idx + 1] + 0.114 * data[idx + 2];
          }

          var lap = [];
          for (var y = 1; y < SIZE - 1; y++) {
            for (var x = 1; x < SIZE - 1; x++) {
              var val = Math.abs(
                -4 * gray[y * SIZE + x] +
                gray[(y - 1) * SIZE + x] +
                gray[(y + 1) * SIZE + x] +
                gray[y * SIZE + (x - 1)] +
                gray[y * SIZE + (x + 1)]
              );
              lap.push(val);
            }
          }

          // Calculate variance
          if (!lap.length) return 999999;
          var sum = 0;
          for (var j = 0; j < lap.length; j++) sum += lap[j];
          var mean = sum / lap.length;
          var variance = 0;
          for (var k = 0; k < lap.length; k++) {
            variance += (lap[k] - mean) * (lap[k] - mean);
          }
          return variance / lap.length;
        } catch (e) {
          return 999999;
        }
      }


  
      async function ensurePoseReady() {
        if (poseReady) {
          return;
        }
        // Poll up to 8s for MediaPipe WASM to finish loading (defer has no guaranteed timing)
        var waited = 0;
        while (!window.Pose && waited < 8000) {
          await new Promise(function (r) { setTimeout(r, 200); });
          waited += 200;
        }
        if (!window.Pose) {
          throw new Error("MediaPipe failed to load. Please refresh.");
        }
  
        pose = new window.Pose({
          locateFile: function (file) {
            return "https://cdn.jsdelivr.net/npm/@mediapipe/pose/" + file;
          }
        });
        pose.setOptions({
          modelComplexity: 1,
          smoothLandmarks: true,
          enableSegmentation: false,
          minDetectionConfidence: 0.5,
          minTrackingConfidence: 0.5
        });
        pose.onResults(function (results) {
          if (results && results.poseLandmarks && results.poseLandmarks.length) {
            poseMissStreak = 0;
            latestPoseLandmarks = results.poseLandmarks;
            if (hasPersonInLandmarks(results.poseLandmarks)) {
              lastHumanDetected = true;
            }
          } else {
            poseMissStreak += 1;
            if (poseMissStreak >= 1) {
              latestPoseLandmarks = null;
            }
            if (poseMissStreak >= 4) {
              lastHumanDetected = false;
            }
          }
        });
  
        poseReady = true;
      }

      // Serialised queue — one send at a time, stable single onResults handler
      var faceDetectQueue = [];

      async function ensureFaceDetectorReady() {
        if (faceDetectorReady) {
          return;
        }
        // Poll up to 8s for FaceDetection WASM
        var waited = 0;
        while (!window.FaceDetection && waited < 8000) {
          await new Promise(function (r) { setTimeout(r, 200); });
          waited += 200;
        }
        if (!window.FaceDetection) {
          throw new Error("MediaPipe FaceDetection failed to load.");
        }
        faceDetector = new window.FaceDetection({
          locateFile: function (file) {
            return "https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/" + file;
          }
        });
        faceDetector.setOptions({
          model: "short",
          minDetectionConfidence: cameraFacingMode === "environment" ? 0.4 : 0.5
        });
        // Register ONE stable handler — resolves the head of the queue
        faceDetector.onResults(function (results) {
          var found = results && results.detections && results.detections.length > 0;
          var next = faceDetectQueue.shift();
          if (next) { next(found); }
        });
        faceDetectorReady = true;
      }

      // Returns promise resolving to true/false — serialised, no race condition
      async function detectFaceInSource(source, minConfidence) {
        await ensureFaceDetectorReady();
        if (faceDetector && typeof faceDetector.setOptions === "function") {
          var gateConfidence =
            typeof minConfidence === "number"
              ? minConfidence
              : cameraFacingMode === "environment"
                ? 0.35
                : 0.4;
          faceDetector.setOptions({
            model: isFullBodyFraming() ? "full" : "short",
            minDetectionConfidence: gateConfidence
          });
        }
        // Always pass a canvas — HTMLImageElement fails silently on Safari/Firefox
        var sendTarget = source;
        if (source && source.tagName === "IMG") {
          var tmpC = document.createElement("canvas");
          tmpC.width = source.naturalWidth || source.width || 1;
          tmpC.height = source.naturalHeight || source.height || 1;
          tmpC.getContext("2d").drawImage(source, 0, 0);
          sendTarget = tmpC;
        }
        return new Promise(function (resolve) {
          faceDetectQueue.push(resolve);
          faceDetector.send({ image: sendTarget }).catch(function () {
            var idx = faceDetectQueue.indexOf(resolve);
            if (idx !== -1) { faceDetectQueue.splice(idx, 1); }
            resolve(false);
          });
        });
      }
  
      function syncPoseConfidenceForFacing() {
        if (!pose || typeof pose.setOptions !== "function") {
          return;
        }
        var rear = cameraFacingMode === "environment";
        var fullBody = isFullBodyFraming();
        pose.setOptions({
          modelComplexity: 1,
          smoothLandmarks: true,
          enableSegmentation: false,
          minDetectionConfidence: rear || fullBody ? 0.28 : 0.5,
          minTrackingConfidence: rear || fullBody ? 0.28 : 0.5
        });
      }
  
      function startCountdownIfEligible() {
        // Auto-capture removed. Manual Capture button is used instead.
      }

      function cancelCaptureCountdown() {
        if (captureCountdownTimer) {
          clearInterval(captureCountdownTimer);
          captureCountdownTimer = null;
        }
        setCountdownValue("");
      }
  
      function doCapture() {
        cancelCaptureCountdown();
        captureFromCamera().catch(function (err) {
          console.error("[TryOn] captureFromCamera error:", err);
          setCaptureBusy(false);
          setCameraInstruction("Stand in middle for accurate outputs.");
          setCaptureError("Capture failed. Please try again.");
        });
      }

      function startCaptureWithTimer(seconds) {
        var remaining = seconds;
        setCountdownValue(remaining);
        captureCountdownTimer = setInterval(function () {
          remaining -= 1;
          if (remaining <= 0) {
            cancelCaptureCountdown();
            timerButtons.forEach(function (b) { b.classList.remove("is-active"); });
            doCapture();
          } else {
            setCountdownValue(remaining);
          }
        }, 1000);
      }
  
      async function handleCaptureButtonClick(event) {
        if (event) {
          event.stopPropagation();
        }
        if (currentState !== "camera" || isLoading) {
          return;
        }
        if (isCameraCaptureInProgress) {
          return;
        }
        setCaptureBusy(true, "Capturing…");
        setCaptureError("");
        setCameraError("");
        captureFromCamera().catch(function (err) {
          console.error("[TryOn] Capture button error:", err);
          setCaptureBusy(false);
          setCameraInstruction(getBodyWaitingMessage());
          setCaptureError("Capture failed. Please try again.");
        });
      }
  
      function isQuarterTurn() {
        return cameraRotation === 90 || cameraRotation === 270;
      }

      /* Frame dimensions once rotated; a quarter turn swaps the axes. */
      function getRotatedFrameSize(frameWidth, frameHeight) {
        return isQuarterTurn()
          ? { width: frameHeight, height: frameWidth }
          : { width: frameWidth, height: frameHeight };
      }

      /* Bakes the rotation into a canvas so the captured photo comes out upright. At 0
         degrees the video element is handed back as-is, so nothing is copied. */
      function getRotatedSource() {
        if (!video) {
          return null;
        }
        var frameWidth = video.videoWidth || 0;
        var frameHeight = video.videoHeight || 0;
        if (frameWidth < 2 || frameHeight < 2) {
          return null;
        }
        if (!cameraRotation) {
          return { source: video, width: frameWidth, height: frameHeight };
        }

        var rotated = getRotatedFrameSize(frameWidth, frameHeight);
        if (!rotatedFrameCanvas) {
          rotatedFrameCanvas = document.createElement("canvas");
        }
        if (rotatedFrameCanvas.width !== rotated.width || rotatedFrameCanvas.height !== rotated.height) {
          rotatedFrameCanvas.width = rotated.width;
          rotatedFrameCanvas.height = rotated.height;
        }

        /* The turned frame covers the canvas exactly, so no clear is needed. */
        var ctx = rotatedFrameCanvas.getContext("2d");
        ctx.save();
        ctx.translate(rotated.width / 2, rotated.height / 2);
        ctx.rotate((cameraRotation * Math.PI) / 180);
        ctx.drawImage(video, -frameWidth / 2, -frameHeight / 2, frameWidth, frameHeight);
        ctx.restore();

        return { source: rotatedFrameCanvas, width: rotated.width, height: rotated.height };
      }

      /* A CSS rotation keeps the element's original layout box, so a quarter turn needs an
         extra scale to pull the turned frame back inside the container. */
      function getRotationFitScale() {
        if (!isQuarterTurn()) {
          return 1;
        }
        var frameWidth = video.videoWidth || 0;
        var frameHeight = video.videoHeight || 0;
        var boxWidth = video.clientWidth || 0;
        var boxHeight = video.clientHeight || 0;
        if (frameWidth < 2 || frameHeight < 2 || boxWidth < 2 || boxHeight < 2) {
          return 0;
        }

        /* object-fit: contain has already fitted the unrotated frame into the box. */
        var containScale = Math.min(boxWidth / frameWidth, boxHeight / frameHeight);
        return Math.min(
          boxWidth / (frameHeight * containScale),
          boxHeight / (frameWidth * containScale)
        );
      }

      function syncRotationBadge() {
        if (cameraRotateBadge) {
          cameraRotateBadge.textContent = cameraRotation + "\u00B0";
        }
      }

      /* Turns the live feed to the shopper's saved rotation. */
      function syncCameraView() {
        if (!video || currentState !== "camera") {
          return;
        }
        if (!cameraRotation) {
          video.style.transform = "";
          return;
        }
        var fitScale = getRotationFitScale();
        if (!fitScale) {
          return;
        }
        video.style.transform = "rotate(" + cameraRotation + "deg) scale(" + fitScale + ")";
      }

      function rotateCameraView(event) {
        if (event) {
          event.stopPropagation();
        }
        var nextIndex = (TRYON_ROTATION_STEPS.indexOf(cameraRotation) + 1) % TRYON_ROTATION_STEPS.length;
        cameraRotation = TRYON_ROTATION_STEPS[nextIndex];
        writeStoredRotation(cameraRotation);
        syncRotationBadge();
        syncCameraView();
      }
  
      async function blobToDataUrl(fileBlob) {
        return new Promise(function (resolve, reject) {
          var reader = new FileReader();
          reader.onload = function () {
            resolve(reader.result || "");
          };
          reader.onerror = function () {
            reject(new Error("Failed to read image."));
          };
          reader.readAsDataURL(fileBlob);
        });
      }
  
      function stripDataUrlToRawBase64(dataUrl) {
        if (!dataUrl || typeof dataUrl !== "string") {
          return "";
        }
        var trimmed = dataUrl.trim();
        var marker = "base64,";
        var idx = trimmed.indexOf(marker);
        if (idx !== -1) {
          return trimmed.slice(idx + marker.length);
        }
        return trimmed;
      }
  
      function canvasToJpegBlob(canvas) {
        return new Promise(function (resolve, reject) {
          canvas.toBlob(
            function (blob) {
              if (blob) {
                resolve(blob);
              } else {
                reject(new Error("Could not encode JPEG."));
              }
            },
            "image/jpeg",
            TRYON_JPEG_QUALITY
          );
        });
      }
  
      async function blobToJpegBase64(fileBlob) {
        var jpegBlob = fileBlob;
        var type = (fileBlob && fileBlob.type) || "";
        if (type.indexOf("jpeg") === -1 && type.indexOf("jpg") === -1) {
          var sourceUrl = URL.createObjectURL(fileBlob);
          try {
            var sourceImage = await imageFromUrl(sourceUrl);
            var tempCanvas = document.createElement("canvas");
            tempCanvas.width = sourceImage.naturalWidth || sourceImage.width;
            tempCanvas.height = sourceImage.naturalHeight || sourceImage.height;
            tempCanvas.getContext("2d").drawImage(sourceImage, 0, 0, tempCanvas.width, tempCanvas.height);
            jpegBlob = await canvasToJpegBlob(tempCanvas);
          } finally {
            URL.revokeObjectURL(sourceUrl);
          }
        }
        var dataUrl = await blobToDataUrl(jpegBlob);
        return {
          base64: stripDataUrlToRawBase64(dataUrl),
          mimeType: "image/jpeg"
        };
      }
  
      async function imageUrlToJpegBase64(imageUrl) {
        var sourceImage;
        try {
          sourceImage = await imageFromUrl(imageUrl, true);
        } catch (corsErr) {
          sourceImage = await imageFromUrl(imageUrl, false);
        }
        var tempCanvas = document.createElement("canvas");
        tempCanvas.width = sourceImage.naturalWidth || sourceImage.width;
        tempCanvas.height = sourceImage.naturalHeight || sourceImage.height;
        tempCanvas.getContext("2d").drawImage(sourceImage, 0, 0, tempCanvas.width, tempCanvas.height);
        var jpegBlob = await canvasToJpegBlob(tempCanvas);
        var dataUrl = await blobToDataUrl(jpegBlob);
        return {
          base64: stripDataUrlToRawBase64(dataUrl),
          mimeType: "image/jpeg"
        };
      }
  
      function findDecodableImageFromJson(node, depth) {
        depth = depth || 0;
        if (!node || depth > 12) {
          return null;
        }
        if (typeof node === "string") {
          try {
            var blob = dataUrlToBlob(node);
            return blob && blob.size > 0 ? blob : null;
          } catch (decodeErr) {
            return null;
          }
        }
        if (Array.isArray(node)) {
          var i;
          for (i = 0; i < node.length; i++) {
            var fromArray = findDecodableImageFromJson(node[i], depth + 1);
            if (fromArray) {
              return fromArray;
            }
          }
          return null;
        }
        if (typeof node !== "object") {
          return null;
        }
        var preferredKeys = [
          "resultImageBase64",
          "result_image_base64",
          "image",
          "result_image",
          "image_base64",
          "result",
          "output",
          "data",
          "url",
          "image_url",
          "result_url"
        ];
        var k;
        for (k = 0; k < preferredKeys.length; k++) {
          if (node[preferredKeys[k]] != null) {
            var fromKey = findDecodableImageFromJson(node[preferredKeys[k]], depth + 1);
            if (fromKey) {
              return fromKey;
            }
          }
        }
        for (var key in node) {
          if (Object.prototype.hasOwnProperty.call(node, key)) {
            var nested = findDecodableImageFromJson(node[key], depth + 1);
            if (nested) {
              return nested;
            }
          }
        }
        return null;
      }
  
      function rawBase64ToBlob(base64, mimeType) {
        if (!base64 || typeof base64 !== "string") {
          return null;
        }
        var normalized = base64.trim();
        if (!normalized) {
          return null;
        }
        if (normalized.indexOf("data:") === 0) {
          return dataUrlToBlob(normalized);
        }
        var mime = mimeType && typeof mimeType === "string" ? mimeType.trim() : "image/png";
        return dataUrlToBlob("data:" + mime + ";base64," + normalized);
      }
  
      async function parseTryonSuccessResponse(response) {
        var contentType = (response.headers.get("Content-Type") || "").toLowerCase();
        if (contentType.indexOf("image/") !== -1) {
          return response.blob();
        }
        var bodyText = await response.text();
        var data = null;
        try {
          data = JSON.parse(bodyText);
        } catch (parseErr) {
          throw new Error("Try-on API returned a non-image, non-JSON response.");
        }
        if (data && data.success === false) {
          throw new Error(extractTryonApiErrorMessage(data, bodyText, response.status));
        }
        if (data && typeof data.resultImageBase64 === "string" && data.resultImageBase64.trim()) {
          var resultBlob = rawBase64ToBlob(data.resultImageBase64, data.mimeType);
          if (resultBlob && resultBlob.size > 0) {
            return resultBlob;
          }
          throw new Error("Try-on API returned an invalid result image.");
        }
        var blob = findDecodableImageFromJson(data);
        if (blob) {
          return blob;
        }
        var urlCandidate =
          data &&
          (data.result_url ||
            data.image_url ||
            data.url ||
            (data.output && (data.output.url || data.output.result_url)));
        if (urlCandidate && typeof urlCandidate === "string") {
          return urlToBlob(urlCandidate);
        }
        throw new Error(extractTryonApiErrorMessage(data, bodyText, response.status));
      }
  
      async function urlToBlob(imageUrl) {
        var response = await fetch(imageUrl);
        if (!response.ok) {
          throw new Error("Could not load generated image.");
        }
        return response.blob();
      }
  
      function dataUrlToBlob(value) {
        if (!value || typeof value !== "string") {
          return null;
        }
  
        var normalized = value.trim();
        if (!normalized) {
          return null;
        }
  
        // Support both full data URLs and raw base64 payloads.
        if (normalized.indexOf("data:") !== 0) {
          normalized = "data:image/jpeg;base64," + normalized;
        }
  
        var parts = normalized.split(",");
        if (parts.length < 2) {
          return null;
        }
  
        var header = parts[0];
        var base64 = parts.slice(1).join(",");
        var mimeMatch = header.match(/data:(.*?);base64/);
        var mimeType = mimeMatch && mimeMatch[1] ? mimeMatch[1] : "image/jpeg";
        var binary = atob(base64);
        var length = binary.length;
        var bytes = new Uint8Array(length);
  
        for (var i = 0; i < length; i += 1) {
          bytes[i] = binary.charCodeAt(i);
        }
  
        return new Blob([bytes], { type: mimeType });
      }
  
      async function imageFromUrl(imageUrl, useCrossOrigin) {
        return new Promise(function (resolve, reject) {
          var image = new Image();
          if (useCrossOrigin) {
            image.crossOrigin = "anonymous";
          }
          image.onload = function () {
            resolve(image);
          };
          image.onerror = function () {
            reject(new Error("Failed to decode image."));
          };
          image.src = imageUrl;
        });
      }
  
      async function applyWatermark(inputBlob) {
        try {
          var sourceUrl = URL.createObjectURL(inputBlob);
          var sourceImage = await imageFromUrl(sourceUrl);
          URL.revokeObjectURL(sourceUrl);
  
          var tempCanvas = document.createElement("canvas");
          tempCanvas.width = sourceImage.width;
          tempCanvas.height = sourceImage.height;
          var ctx = tempCanvas.getContext("2d");
          ctx.drawImage(sourceImage, 0, 0, sourceImage.width, sourceImage.height);
  
          var fontSize = Math.max(22, Math.round(sourceImage.width * 0.06));
          ctx.save();
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";
          ctx.font = "700 " + fontSize + "px Arial, sans-serif";
          ctx.lineWidth = Math.max(2, Math.round(fontSize * 0.08));
          ctx.strokeStyle = "rgba(0, 0, 0, 0.24)";
          ctx.fillStyle = "rgba(255, 255, 255, 0.4)";
          ctx.strokeText("SUHAS GROVER", sourceImage.width / 2, sourceImage.height - 3);
          ctx.fillText("SUHAS GROVER", sourceImage.width / 2, sourceImage.height - 3);
          ctx.restore();
  
          var finalBlob = await new Promise(function (resolve) {
            tempCanvas.toBlob(resolve, "image/jpeg", TRYON_JPEG_QUALITY);
          });
          if (!finalBlob) {
            console.warn("[TryOn] Canvas toBlob returned null. Returning original image.");
          }
          return finalBlob || inputBlob;
        } catch (error) {
          console.error("[TryOn] Watermark apply failed.", error);
          return inputBlob;
        }
      }
  
      function submitCustomerDetails(payload) {
        var url = modal.dataset.detailsEndpoint;
        if (!url || !payload) {
          console.warn("[TryOn] Sheet submit skipped: missing endpoint or payload.", { url: !!url, payload: !!payload });
          return Promise.resolve();
        }
        var meta = getProductSubmissionMeta();
        var dialCode =
          payload.code != null && String(payload.code).trim()
            ? String(payload.code).trim()
            : getDialCodeForRegion(payload.countryCode || "");
        var nationalPhone = normalizePhoneDigits(payload.phone);
        var bodyObj = {
          name: String(payload.name || "").trim(),
          code: dialCode,
          phone: nationalPhone,
          productUrl: meta.productUrl,
          productName: meta.productName
        };

        return submitToGoogleSheet(url, bodyObj);
      }

      /** POST JSON in request body — read by Apps Script e.postData.contents */
      function submitToGoogleSheet(url, bodyObj) {
        var body = JSON.stringify(bodyObj);
        return fetch(url, {
          method: "POST",
          mode: "no-cors",
          cache: "no-store",
          headers: {
            "Content-Type": "text/plain;charset=utf-8"
          },
          body: body
        })
          .then(function (response) {
            if (response.type === "opaque") {
              return;
            }
            if (!response.ok) {
              console.warn("[TryOn] Sheet endpoint HTTP error:", response.status, response.statusText);
            }
          })
          .catch(function (error) {
            console.error("[TryOn] Sheet submit failure:", error && error.message ? error.message : error);
          });
      }
  
      function downloadBlob(blob, filename) {
        var fileUrl = URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.href = fileUrl;
        anchor.download = filename || "try-on-result.jpg";
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(fileUrl);
      }
  
      function askCustomerDetails(actionLabel) {
        if (!detailsModal || !detailsNameInput || !detailsPhoneInput || !detailsSubmitButton || !detailsCancelButton) {
          return Promise.resolve(null);
        }
  
        return new Promise(function (resolve) {
          function closePopup(result) {
            setDetailsSubmitBusy(false);
            detailsModal.hidden = true;
            modal.classList.remove("br-tryon-modal--details-open");
            detailsSubmitButton.removeEventListener("click", submitHandler);
            detailsCancelButton.removeEventListener("click", cancelHandler);
            detailsModal.removeEventListener("click", overlayHandler);
            resolve(result);
          }
  
          function submitHandler() {
            if (isDetailsSubmitBusy) {
              return;
            }
            var name = (detailsNameInput.value || "").trim();
            var phoneNational = normalizePhoneDigits(detailsPhoneInput.value);
            var phoneRegion = getSelectedPhoneRegion();
            detailsPhoneInput.value = phoneNational;
            var missingName = !name;
            var missingPhone = !phoneNational;
            var invalidPhone = !validatePhoneForRegion(phoneNational, phoneRegion);
            var consentGiven = detailsConsentInput && detailsConsentInput.checked;
            var phoneE164 = formatPhoneE164(phoneNational, phoneRegion);

            setInputErrorState(detailsNameInput, missingName);
            setInputErrorState(detailsPhoneInput, missingPhone || invalidPhone);
            setInputErrorState(detailsPhoneCountry, missingPhone || invalidPhone);

            if (!name || !phoneNational) {
              setDetailsError("Please enter both name and mobile number.");
              return;
            }
            if (invalidPhone || !phoneE164) {
              setDetailsError("Enter a valid mobile number for the selected country.");
              return;
            }
            if (!consentGiven) {
              setDetailsError("Please give consent for suhasgrover team to contact.");
              return;
            }
            setDetailsError("");
            var dialCode = getSelectedDialCode();
            var payload = {
              name: name,
              phone: phoneNational,
              code: dialCode,
              countryCode: phoneRegion,
              phoneE164: phoneE164,
              consent: true
            };
            setDetailsSubmitBusy(true, getDetailsBusyLabel(actionLabel));
            persistContactSubmitted(payload);
            submitCustomerDetails(payload).finally(function () {
              closePopup(payload);
            });
          }
  
          function cancelHandler() {
            if (isDetailsSubmitBusy) {
              return;
            }
            closePopup(null);
          }
  
          function overlayHandler(event) {
            if (event.target === detailsModal) {
              if (isDetailsSubmitBusy) {
                return;
              }
              closePopup(null);
            }
          }
  
          detailsNameInput.value = "";
          detailsPhoneInput.value = "";
          ensureGlobalPhoneCountrySelect(detailsPhoneCountry);
          if (detailsPhoneCountry) {
            var defaultCountry = detailsPhoneCountry.getAttribute("data-default-country");
            if (defaultCountry) {
              detailsPhoneCountry.value = String(defaultCountry).toUpperCase();
            }
          }
          applyDefaultPhoneFromCustomer();
          if (detailsConsentInput) {
            detailsConsentInput.checked = false;
          }
          setInputErrorState(detailsNameInput, false);
          setInputErrorState(detailsPhoneInput, false);
          if (detailsPhoneCountry) {
            setInputErrorState(detailsPhoneCountry, false);
          }
          setDetailsError("");
          if (actionLabel === "share") {
            detailsSubmitLabel = "Share";
          } else if (actionLabel === "generate") {
            detailsSubmitLabel = "Generate";
          } else {
            detailsSubmitLabel = "Download";
          }
          setDetailsSubmitBusy(false);
          detailsSubmitButton.textContent = detailsSubmitLabel;
          var headline;
          if (actionLabel === "share") {
            headline = "Share details before sharing the image";
          } else if (actionLabel === "generate") {
            headline = "Contact details required for another try-on";
          } else {
            headline = "Share details before downloading the image";
          }
          if (detailsTitleEl) {
            detailsTitleEl.textContent = headline;
          }
          if (detailsInnerDialog) {
            detailsInnerDialog.setAttribute("aria-label", headline);
          }
          detailsModal.hidden = false;
          modal.classList.add("br-tryon-modal--details-open");
          detailsModal.addEventListener("click", overlayHandler);
          detailsSubmitButton.addEventListener("click", submitHandler);
          detailsCancelButton.addEventListener("click", cancelHandler);
          if (actionLabel === "share") {
            setStatus("Enter your details to share.");
          } else if (actionLabel === "generate") {
            setStatus("Enter your details to generate another try-on.");
          } else {
            setStatus("Enter your details to download.");
          }
          detailsNameInput.focus();
        });
      }
  
      async function handleDownload() {
        if (isLoading || isToolbarActionBusy) {
          return;
        }
        if (!generatedBlob) {
          setStatus("Generate image first.");
          return;
        }
        var dailyState = readDailyState();
        var details = dailyState.contact;
        if (!dailyState.contactSubmitted) {
          details = await askCustomerDetails("download");
          if (!details) {
            setStatus("Download cancelled.");
            return;
          }
        }
        setToolbarActionLoading(true, "Downloading…");
        setStatus("");
        try {
          await nextPaint();
          downloadBlob(generatedBlob, generatedFilename);
          setStatus(details && details.name ? "Downloaded for " + details.name + "." : "Downloaded.");
        } catch (err) {
          setStatus("Download failed.", "error");
          console.error("[TryOn] Download error:", err);
        } finally {
          setToolbarActionLoading(false);
        }
      }
  
      async function handleShare() {
        if (isLoading || isToolbarActionBusy) {
          return;
        }
        if (!generatedBlob) {
          setStatus("Generate image first.");
          return;
        }
        var dailyStateShare = readDailyState();
        var details = dailyStateShare.contact;
        if (!dailyStateShare.contactSubmitted) {
          details = await askCustomerDetails("share");
          if (!details) {
            setStatus("Share cancelled.");
            return;
          }
        }
  
        var shareFile = new File([generatedBlob], generatedFilename, { type: "image/jpeg" });
        var shareText =
          details && details.name
            ? "Generated for " + details.name + (details.phone ? " (" + details.phone + ")" : "")
            : "Try-On Result";
        if (navigator.canShare && navigator.canShare({ files: [shareFile] })) {
          setToolbarActionLoading(true, "Sharing…");
          setStatus("");
          try {
            await navigator.share({
              title: "Try-On Result",
              text: shareText,
              files: [shareFile]
            });
            setStatus("Shared successfully.");
          } catch (error) {
            setStatus("Share cancelled.");
          } finally {
            setToolbarActionLoading(false);
          }
        } else {
          setToolbarActionLoading(true, "Downloading…");
          setStatus("");
          try {
            await nextPaint();
            downloadBlob(generatedBlob, generatedFilename);
            setStatus("Share unsupported. Downloaded instead.");
          } catch (err) {
            setStatus("Download failed.", "error");
            console.error("[TryOn] Download error:", err);
          } finally {
            setToolbarActionLoading(false);
          }
        }
      }
  
      /**
       * One rule for camera, upload, and regenerate:
       * - max TRYON_DAILY_LIMIT successful generations per local calendar day
       * - contact already submitted today → never ask again (within daily limit)
       * - first successful generate today (count 0) → free, no ask
       * - any further generate/regenerate → ask once if not submitted
       */
      async function ensureContactForTryOn(statusMessage) {
        var state = readDailyState();
        if (hasReachedDailyTryOnLimit(state)) {
          setStatus(getDailyTryOnLimitMessage(), "error");
          return false;
        }
        if (state.contactSubmitted) {
          return true;
        }
        if (state.generationCount < 1) {
          return true;
        }
        var details = await askCustomerDetails("generate");
        if (!details) {
          setStatus("Contact details are required for another try-on.");
          return false;
        }
        setStatus(statusMessage || "Generating try-on result...");
        setLoading(true);
        return true;
      }
  
      async function requestGeneration(fileBlob, options) {
        options = options || {};
        if (isLoading || isToolbarActionBusy) {
          return;
        }
        if (hasReachedDailyTryOnLimit()) {
          setStatus(getDailyTryOnLimitMessage(), "error");
          setCaptureBusy(false);
          return;
        }
        var contactOk = await ensureContactForTryOn(options.statusMessage);
        if (!contactOk) {
          setCaptureBusy(false);
          return;
        }
        setCaptureBusy(false);
        await sendToApi(fileBlob);
      }
  
      async function sendToApi(fileBlob) {
        var endpoint = modal.dataset.apiEndpoint;
        var apiKey = modal.dataset.apiKey || modal.dataset.apiAuth;
        if (!endpoint) {
          setStatus("API endpoint missing.");
          return;
        }
        if (!apiKey) {
          setStatus("API key missing.");
          return;
        }
  
        var garmentUrl = syncGarmentImage();
        if (!garmentUrl) {
          setStatus("Garment image missing.");
          return;
        }
  
        setStatus("Preparing images...");
        setLoading(true);
        var personEncoded;
        var garmentEncoded;
        try {
          personEncoded = await blobToJpegBase64(fileBlob);
          garmentEncoded = await imageUrlToJpegBase64(garmentUrl);
        } catch (prepErr) {
          setLoading(false);
          setStatus(
            (prepErr && prepErr.message) || "Could not prepare images for try-on.",
            "error"
          );
          console.error("[TryOn] Image prep error:", prepErr);
          return;
        }
  
        if (!personEncoded.base64 || !garmentEncoded.base64) {
          setLoading(false);
          setStatus("Could not prepare model or garment image.", "error");
          return;
        }
  
        var resolution = String(modal.dataset.tryonResolution || "1K").trim().toUpperCase();
        if (resolution !== "1K" && resolution !== "2K" && resolution !== "4K") {
          resolution = "1K";
        }
  
        var payload = {
          personImage: personEncoded.base64,
          garmentMimeType: garmentEncoded.mimeType || "image/jpeg",
          garmentImage: garmentEncoded.base64,
          resolution: resolution
        };
  
        setStatus("Generating try-on result...");
        var abortController = new AbortController();
        var abortTimer = setTimeout(function () { abortController.abort(); }, 600000);
        try {
          var response = await fetch(endpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-Key": apiKey
            },
            body: JSON.stringify(payload),
            signal: abortController.signal
          });
          clearTimeout(abortTimer);
  
          var errBodyText = "";
          if (!response.ok) {
            try {
              errBodyText = await response.text();
            } catch (readErr) {
              console.warn("[TryOn] Could not read API error body:", readErr);
            }
            var errJson = null;
            if (errBodyText) {
              try {
                errJson = JSON.parse(errBodyText);
              } catch (parseErr) {
                /* use raw body text below */
              }
            }
            var errMsg = extractTryonApiErrorMessage(errJson, errBodyText, response.status);
            console.warn("[TryOn] API HTTP error:", response.status, errMsg, errBodyText || errJson);
            throw new Error(errMsg);
          }
  
          var apiResultBlob = await parseTryonSuccessResponse(response);
          if (!apiResultBlob) {
            throw new Error("No result image in API response.");
          }
          var finalBlob = await applyWatermark(apiResultBlob);
          generatedBlob = finalBlob;
          generatedFilename = "try-on-" + Date.now() + ".jpg";
          resultImage.src = URL.createObjectURL(finalBlob);
          setUploadState("result");
          setStatus("Try-on ready.");
          incrementSuccessfulGenerationCount();
        } catch (error) {
          clearTimeout(abortTimer);
          var msg =
            error && error.name === "AbortError"
              ? "Request timed out after 10 minutes. Please retry."
              : (error && error.message && String(error.message).trim()) ||
                "Try-on failed. Please retry.";
          setStatus(msg, "error");
          console.error("[TryOn] Try-on error:", msg, error);
        } finally {
          setLoading(false);
        }
      }
  
      function waitForVideoFrameReady(v, maxMs) {
        maxMs = maxMs || 500;
        if (v.videoWidth >= 2 && v.videoHeight >= 2 && v.readyState >= 2) {
          return Promise.resolve();
        }
        return new Promise(function (resolve) {
          var finished = false;
          function done() {
            if (finished) {
              return;
            }
            finished = true;
            v.removeEventListener("loadeddata", onReady);
            v.removeEventListener("canplay", onReady);
            v.removeEventListener("resize", onReady);
            clearTimeout(tid);
            resolve();
          }
          function onReady() {
            if (v.videoWidth >= 2 && v.videoHeight >= 2) {
              done();
            }
          }
          v.addEventListener("loadeddata", onReady);
          v.addEventListener("canplay", onReady);
          v.addEventListener("resize", onReady);
          var tid = setTimeout(done, maxMs);
        });
      }
  
      function waitNextVideoFrame(el) {
        return new Promise(function (resolve) {
          if (!el) {
            resolve();
            return;
          }
          if (typeof el.requestVideoFrameCallback === "function") {
            el.requestVideoFrameCallback(function () {
              resolve();
            });
          } else {
            requestAnimationFrame(function () {
              resolve();
            });
          }
        });
      }
  
      async function ensureVideoPlaying(v) {
        if (!v) {
          return;
        }
        try {
          if (v.paused) {
            await v.play();
          }
        } catch (playErr) {
          /* stream already playing in most cases */
        }
      }
  
      async function captureFromCamera() {
        if (!video || !canvas) {
          setCaptureBusy(false);
          setCameraInstruction("Stand in middle for accurate outputs.");
          return;
        }

        function drawFrameToCanvas() {
          var frame = getRotatedSource();
          if (!frame) {
            return false;
          }
          /* Canvas matches the camera frame exactly: no crop and no resampling, so the
             photo sent to the API is the same thing the preview showed. */
          canvas.width = frame.width;
          canvas.height = frame.height;
          canvas.getContext("2d").drawImage(frame.source, 0, 0);
          return true;
        }

        function showFrozenPreview() {
          stopCamera();
          previewImage.src = canvas.toDataURL("image/jpeg", TRYON_JPEG_QUALITY);
          setUploadState("preview");
          setCameraInstruction("");
        }

        if (!drawFrameToCanvas()) {
          await ensureVideoPlaying(video);
          await waitForVideoFrameReady(video, 400);
          if (!drawFrameToCanvas()) {
            setCaptureBusy(false);
            setCameraInstruction("Stand in middle for accurate outputs.");
            setCaptureError("Could not read camera frame. Tap Capture to retry.");
            return;
          }
        }

        showFrozenPreview();

        setCaptureBusy(false);
        setStatus("Captured. Sending to try-on...");

        var blob = await new Promise(function (resolve) {
          canvas.toBlob(resolve, "image/jpeg", TRYON_JPEG_QUALITY);
        });

        if (!blob) {
          setCameraInstruction("Stand in middle for accurate outputs.");
          setCaptureError("Could not capture image. Please try again.");
          return;
        }

        lastSourceBlob = blob;
        var objectUrl = URL.createObjectURL(blob);
        previewImage.src = objectUrl;
        requestGeneration(blob);
      }
  
      async function startCameraAndAutoCapture() {
        stopCamera();
        cameraFacingMode = "user";
        syncGarmentImage();
        setStatus("Requesting camera permission...");
  
        try {
          await attachLiveCameraStream();
          setUploadState("camera");
          setStatus("Stand in middle for accurate outputs.");
          setCameraInstruction("Stand in middle for accurate outputs.");
        } catch (error) {
          setStatus("Camera permission denied or unavailable.");
        }
      }
  
      function resetCameraCountdownState() {
        if (countdownInterval) {
          clearInterval(countdownInterval);
          countdownInterval = null;
        }
        setCountdownValue("");
      }
  
      async function flipCameraFacing(event) {
        if (event) {
          event.stopPropagation();
        }
        if (currentState !== "camera" || isLoading || isCameraCaptureInProgress || !video) {
          return;
        }
        var previousMode = cameraFacingMode;
        cameraFacingMode = previousMode === "user" ? "environment" : "user";
        setStatus("Switching camera…");
        try {
          if (stream) {
            stream.getTracks().forEach(function (track) {
              track.stop();
            });
            stream = null;
          }
          await attachLiveCameraStream();
          resetCameraCountdownState();
          syncCameraView();
          setStatus("Stand in middle for accurate outputs.");
          setCameraInstruction("Stand in middle for accurate outputs.");
        } catch (err) {
          cameraFacingMode = previousMode;
          try {
            await attachLiveCameraStream();
            resetCameraCountdownState();
            syncCameraView();
            setStatus("Stand in middle for accurate outputs.");
            setCameraInstruction("Stand in middle for accurate outputs.");
          } catch (err2) {
            setStatus("Could not switch camera. Try again.", "error");
            console.warn("[TryOn] Flip camera failed:", err, err2);
          }
        }
      }
  
      function openModal(triggerButton) {
        activeGarmentOverride = "";
        var garmentFromButton = getGarmentUrlFromButton(triggerButton);
        if (garmentFromButton) {
          activeGarmentOverride = garmentFromButton;
        }
        var garmentUrl = syncGarmentImage();
        if (!garmentUrl && garmentFromButton) {
          activeGarmentOverride = garmentFromButton;
          garmentUrl = syncGarmentImage();
        }
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        showPageBackdrop();
        document.body.classList.add("overflow-hidden");
        document.documentElement.classList.add("br-tryon-modal-open");
        if (!contextMenuBlocker) {
          contextMenuBlocker = function (event) {
            if (modal.classList.contains("is-open")) {
              event.preventDefault();
            }
          };
        }
        document.addEventListener("contextmenu", contextMenuBlocker);
        setCaptureBusy(false);
        setUploadState("empty");
        setLoading(false);
        setToolbarActionLoading(false);
        cameraFacingMode = "user";
        setStatus("Choose camera or upload to start try-on.");
        previewImage.src = "";
        resultImage.src = "";
      }
  
      function closeModal() {
        activeGarmentOverride = "";
        modal.classList.remove("is-open");
        modal.classList.remove("br-tryon-modal--details-open");
        modal.setAttribute("aria-hidden", "true");
        hidePageBackdrop();
        document.body.classList.remove("overflow-hidden");
        document.documentElement.classList.remove("br-tryon-modal-open");
        if (contextMenuBlocker) {
          document.removeEventListener("contextmenu", contextMenuBlocker);
        }
        if (detailsModal) {
          detailsModal.hidden = true;
        }
        setToolbarActionLoading(false);
        setCaptureBusy(false);
        stopCamera();
      }
  
      openButtons.forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          openModal(btn);
        });
      });
      closeButtons.forEach(function (button) {
        button.addEventListener("click", closeModal);
      });
  
      cameraButton.addEventListener("click", startCameraAndAutoCapture);
      chooseButton.addEventListener("click", function () {
        fileInput.click();
      });
  
      uploadBox.addEventListener("click", function (event) {
        if (event.target && event.target.closest(".br-tryon-toolbar-stack")) {
          return;
        }
        if (event.target && event.target.closest(".br-tryon-camera-flip")) {
          return;
        }
        if (event.target && event.target.closest(".br-tryon-capture-btn-row")) {
          return;
        }
        if (detailsModal && !detailsModal.hidden) {
          return;
        }
        if (currentState !== "camera") {
          fileInput.click();
        }
      });
  
      async function validateCaptureWithPose(imgEl, blob, objectUrl) {
        var garmentUrl = getActiveGarmentUrl();
        var garmentType = await detectGarmentType(garmentUrl);
        
        function reject(msg) {
          resumeCameraAfterCaptureError(msg, objectUrl);
        }
        function accept() {
          setStatus("Captured. Sending to try-on...");
          setCaptureBusy(false);
          requestGeneration(blob);
        }

        // ONLY for lower garments, verify face/waist/knees regions with OpenCV
        if (garmentType === 'lower') {
          var hasFullBody = await verifyFullBodyRegionsWithOpenCV(imgEl, garmentType);
          if (!hasFullBody) {
            reject("For this garment, full body photo required showing face, waist, and knees.");
            return;
          }
        }

        if (!window.Pose) { accept(); return; }

        var sw = imgEl.naturalWidth || imgEl.width || 1;
        var sh = imgEl.naturalHeight || imgEl.height || 1;
        var poseCanvas = document.createElement("canvas");
        poseCanvas.width = sw;
        poseCanvas.height = sh;
        poseCanvas.getContext("2d").drawImage(imgEl, 0, 0);

        var oneShotPose = new window.Pose({
          locateFile: function (f) {
            return "https://cdn.jsdelivr.net/npm/@mediapipe/pose/" + f;
          }
        });
        oneShotPose.setOptions({
          modelComplexity: 1,
          smoothLandmarks: false,
          enableSegmentation: false,
          minDetectionConfidence: 0.3,
          minTrackingConfidence: 0.3
        });
        oneShotPose.onResults(function (results) {
          var lm = results && results.poseLandmarks ? results.poseLandmarks : null;

          if (!lm || !lm.length) {
            reject("No person detected. Please try again.");
            return;
          }

          var nose = lm[0];
          var leftShoulder = lm[11];
          var rightShoulder = lm[12];
          var leftHip = lm[23];
          var rightHip = lm[24];
          var leftKnee = lm[25];
          var rightKnee = lm[26];
          var leftAnkle = lm[27];
          var rightAnkle = lm[28];

          // Get visibility scores
          var leftHipVis = (leftHip && typeof leftHip.visibility === 'number') ? leftHip.visibility : 0;
          var rightHipVis = (rightHip && typeof rightHip.visibility === 'number') ? rightHip.visibility : 0;
          var bestHipVis = Math.max(leftHipVis, rightHipVis);
          
          var leftKneeVis = (leftKnee && typeof leftKnee.visibility === 'number') ? leftKnee.visibility : 0;
          var rightKneeVis = (rightKnee && typeof rightKnee.visibility === 'number') ? rightKnee.visibility : 0;
          var bestKneeVis = Math.max(leftKneeVis, rightKneeVis);
          
          var leftAnkleVis = (leftAnkle && typeof leftAnkle.visibility === 'number') ? leftAnkle.visibility : 0;
          var rightAnkleVis = (rightAnkle && typeof rightAnkle.visibility === 'number') ? rightAnkle.visibility : 0;
          var bestAnkleVis = Math.max(leftAnkleVis, rightAnkleVis);

          console.log('[TryOn] CAPTURE - Body coverage check:', {
            garmentType: garmentType,
            bestHipVis: bestHipVis.toFixed(3),
            bestKneeVis: bestKneeVis.toFixed(3),
            bestAnkleVis: bestAnkleVis.toFixed(3)
          });

          // CRITICAL: REJECT face-only, neck-only, shoulder-only photos for ALL garment types
          // For ALL garments: At minimum, chest must be visible (not just shoulders)
          // Check if chest region (below shoulders) is visible
          var leftElbow = lm[13];
          var rightElbow = lm[14];
          var leftElbowVis = (leftElbow && typeof leftElbow.visibility === 'number') ? leftElbow.visibility : 0;
          var rightElbowVis = (rightElbow && typeof rightElbow.visibility === 'number') ? rightElbow.visibility : 0;
          var bestElbowVis = Math.max(leftElbowVis, rightElbowVis);
          
          // For upper/fullbody: chest area must be visible (elbows or hips as proxy)
          if (garmentType !== 'lower') {
            // At least elbows OR hips must be visible (indicates chest is in frame)
            var hasChestArea = bestElbowVis > 0.25 || bestHipVis > 0.25;
            if (!hasChestArea) {
              reject("Photo must show at least chest area. Head-to-shoulder only photos are not accepted.");
              return;
            }
          }
          
          // For lower garments: waist must be visible
          if (garmentType === 'lower' && bestHipVis < 0.35) {
            reject("For pants, photo must show at least from head to waist. Please step back.");
            return;
          }

          // FOR LOWER GARMENTS: Require full body with knees visible
          if (garmentType === 'lower') {
            if (bestKneeVis < 0.6) {
              reject("For pants, full body photo required from head to knees. Please step back.");
              return;
            }
            
            if (bestAnkleVis < 0.35) {
              reject("For pants, full body photo required showing legs clearly. Please step back.");
              return;
            }
            
            var kneeY1 = (leftKnee && typeof leftKnee.y === 'number') ? leftKnee.y : 0;
            var kneeY2 = (rightKnee && typeof rightKnee.y === 'number') ? rightKnee.y : 0;
            var ankleY1 = (leftAnkle && typeof leftAnkle.y === 'number') ? leftAnkle.y : 0;
            var ankleY2 = (rightAnkle && typeof rightAnkle.y === 'number') ? rightAnkle.y : 0;
            var maxBodyY = Math.max(kneeY1, kneeY2, ankleY1, ankleY2);
            
            if (maxBodyY < 0.85) {
              reject("For pants, full body photo required showing complete legs.");
              return;
            }
          }

          // FOR UPPER/FULLBODY GARMENTS: Allow head-to-waist OR head-to-toe (waist already checked above)
          // No additional checks needed - waist visibility is sufficient

          // Continue with face detection checks
          // Continue with face detection checks
          var leftEye = lm[2];
          var rightEye = lm[5];
          var leftEar = lm[7];
          var rightEar = lm[8];
          var mouth = lm[10];

          if (!nose) {
            reject("Face not detected. Please show your face clearly.");
            return;
          }

          var leftEyeVis = (leftEye && leftEye.visibility) || 0;
          var rightEyeVis = (rightEye && rightEye.visibility) || 0;
          var mouthVis = (mouth && mouth.visibility) || 0;
          
          var bothEyesVisible = leftEyeVis > 0.4 && rightEyeVis > 0.4;
          var oneEyeAndMouth = (leftEyeVis > 0.5 || rightEyeVis > 0.5) && mouthVis > 0.5;
          var mouthOnly = mouthVis > 0.6 && leftEyeVis < 0.2 && rightEyeVis < 0.2;
          
          var isFrontFacing = bothEyesVisible || oneEyeAndMouth || mouthOnly;
          
          if (!isFrontFacing) {
            reject("Please face the camera. Retake with a front-facing pose.");
            return;
          }
          
          if (leftEye && rightEye && leftEyeVis > 0.3 && rightEyeVis > 0.3) {
            var eyeSpread = Math.abs(leftEye.x - rightEye.x);
            if (eyeSpread < 0.04) {
              reject("Please face the camera. Retake with a front view, not a side view.");
              return;
            }
          }

          if (!leftShoulder && !rightShoulder) {
            reject("Shoulders not visible. Please step back to show your upper body.");
            return;
          }

          var eyesDetected = leftEye && rightEye;
          
          if (eyesDetected) {
            var eyeSpread = Math.abs(leftEye.x - rightEye.x);
            if (eyeSpread < 0.02) {
              reject("Please face the camera. Retake with a front view, not a back view.");
              return;
            }
          }
          
          if (leftShoulder && rightShoulder) {
            var shoulderXSpread = Math.abs(leftShoulder.x - rightShoulder.x);
            var shoulderYDiff = Math.abs(leftShoulder.y - rightShoulder.y);
            
            if (shoulderXSpread < 0.12) {
              reject("Please face the camera. Retake with a front view, not a back view.");
              return;
            }
            
            if (shoulderYDiff > 0.12) {
              reject("Please face the camera. Retake with a front view, not a side angle.");
              return;
            }
          }

          if (nose.y < 0.05) {
            reject("Face is cropped. Please step back to show your full face.");
            return;
          }

          var bestShoulder = leftShoulder || rightShoulder;
          if (bestShoulder && bestShoulder.y <= nose.y) {
            reject("Upper body is cropped. Please step back to show shoulders.");
            return;
          }

          accept();
        });

        oneShotPose.send({ image: poseCanvas }).catch(function () {
          reject("Unable to detect body pose. Please try again with a clearer photo.");
        });
      }

      fileInput.addEventListener("change", function (event) {
        var file = event.target.files && event.target.files[0];
        if (!file) {
          return;
        }
  
        stopCamera();
        lastSourceBlob = file;
        previewImage.src = URL.createObjectURL(file);
        setUploadState("preview");
        setStatus("Uploading selected photo...");
        requestGeneration(file);
      });
  
      regenerateButton.addEventListener("click", function () {
        if (isLoading || isToolbarActionBusy) {
          return;
        }
        if (!lastSourceBlob) {
          setStatus("Capture or upload first, then regenerate.");
          return;
        }
        requestGeneration(lastSourceBlob, { statusMessage: "Regenerating..." });
      });
  
      if (captureButton) {
        captureButton.addEventListener("click", handleCaptureButtonClick);
      }

      [shareButton, downloadButton, regenerateButton, cameraFlipButton, cameraRotateButton].forEach(function (button) {
        if (!button) {
          return;
        }
        button.addEventListener("click", function (event) {
          event.stopPropagation();
        });
      });
  
      if (cameraFlipButton) {
        cameraFlipButton.addEventListener("click", flipCameraFacing);
      }
  
      if (cameraRotateButton) {
        cameraRotateButton.addEventListener("click", rotateCameraView);
        syncRotationBadge();
      }
  
      /* The fit scale depends on the frame and container size, so re-apply whenever
         either can have changed. syncCameraView no-ops outside the camera state. */
      video.addEventListener("loadedmetadata", syncCameraView);
      video.addEventListener("resize", syncCameraView);
      window.addEventListener("resize", syncCameraView);
  
      downloadButton.addEventListener("click", handleDownload);
      shareButton.addEventListener("click", handleShare);
  
      modal.addEventListener("click", function (event) {
        if (event.target === modal) {
          closeModal();
        }
      });
  
      document.addEventListener("variant:change", function () {
        activeGarmentOverride = "";
        syncGarmentImage();
      });

      var detailRoot = getProductDetailRoot();
      if (detailRoot) {
        detailRoot.addEventListener("click", function (event) {
          if (
            event.target.closest(
              ".thumbnail-list, .thumbnail-list__item, button.thumbnail, .slider-button, .product__media-item"
            )
          ) {
            activeGarmentOverride = "";
            window.setTimeout(syncGarmentImage, 0);
            window.setTimeout(syncGarmentImage, 120);
          }
        });

        var galleryList = detailRoot.querySelector(".product__media-list, .product__media-wrapper, media-gallery");
        if (galleryList && typeof MutationObserver !== "undefined") {
          var galleryObserver = new MutationObserver(function () {
            if (modal.classList.contains("is-open")) {
              activeGarmentOverride = "";
            }
            syncGarmentImage();
          });
          galleryObserver.observe(galleryList, {
            subtree: true,
            attributes: true,
            attributeFilter: ["class", "aria-current", "aria-hidden"]
          });
        }
      }
  
    }
  
    function boot() {
      document.querySelectorAll("[data-tryon-root]").forEach(initTryOn);
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
  })();
  